/* eslint-disable react-hooks/rules-of-hooks */
/**
 * Created by rastwe on 1/26/2017.
 */

import {
	AlwaysRenamableDocumentTypeIds,
	ArcCheckLstTypes,
	ArcCheckLstTypesObject,
	ArcTimeLineValidationTypes,
	ArcTimelineTypes,
	COUNT,
	CanvasFormsIds,
	ClientRequestStatus,
	DisabledDocumentTypeIDs,
	DrillDownCategories,
	DrillDownMiscConstants,
	EngagementClientYearEndDate,
	EngagementRoles,
	EngagementSource,
	EngagementStatus,
	GALinkStatus,
	GetTaskStatus,
	GuidedWorkflowV2DocumentTypes,
	ISA220ValidationsDate,
	KnowledgeTaskTypes,
	OfflineTaskListFilters,
	OpenInCanvasDocumentTypeIDs,
	PaperProfileIds,
	ReadOnlyDocumentTypeIds,
	RestrictedDocumentFileExt,
	ReviewTypeSourceIds,
	SearchTypes,
	SmartAutomationEvidenceIds,
	SmartFormIds,
	TaskCategories,
	TaskListSortFields,
	TaskStatusIds,
	TaskType,
	TaskTypeEnum,
	ValidationGroup,
	activityTypeRoute,
	assignmentApiRoutes,
	canvasUrlParams,
	canvasWebRoutes,
	categoryMapping,
	circleProportions,
	collaborationFilterTypeEnum,
	collaborationQuickFiltersTabsConstanst,
	confidentialityTypes,
	dateFormats,
	dateTimeFormats,
	defaultClientTagColor,
	defaultCurrentPage,
	defaultDateFormat,
	defaultEYTagColor,
	defaultPageSize,
	documentCategoryNames,
	documentGetAllParamNames,
	documentNameMaxLength,
	documentTabLayoutTabs,
	documentTypes,
	DocumentStatus,
	ContentContract,
	emptyGuid,
	engagementCommentStatus,
	entities,
	fileExtensionMapping,
	filters,
	findingType,
	invalidClientCode,
	numberFormatsListItems,
	relateRequestType,
	reviewNoteRoutes,
	reviewNoteStatus,
	reviewNotesType,
	serviceURL,
	signOffRequirementsClientYearDate,
	smartScreenRoutes,
	taskApiRoutes,
	taskAttributes,
	userTheme,
	validationTypes,
	buildStepTaskMilestoneIds,
	StrategyTypeIds,
	ParentPendingResponse,
	multiEntityTypes,
	QuickFilterActionTypes,
	QuickFilterTypes
} from './uiconstants';
import React, {useEffect, useState} from 'react';
import {
	actionIcCheckCircle24px,
	actionIcQueryBuilder24px,
	alertIcError24px
} from '@ey/motif-react-wrapper/assets/icons/index';
import {applyRound, numberFormattedText} from '@ey/utils';
import {currentResource, isNullOrUndefined, isNullOrWhitespace, labels} from './utils';
import Moment from 'react-moment';
import _ from 'lodash';
import dompurify from 'dompurify';
import env from '../util/env';
import envConfig from '@ey/voltron-config';
import {getTheme} from '@ey/styled-theme';
import moment from 'moment';
import queryString from 'query-string';
import uuidv4 from 'uuid/v4';
import MotifButton from '@ey/motif-react-wrapper/Button';
import {benefitServiceIntegrationAction} from '../actions/Benefit/benefitServiceIntegrationAction';

class Utility extends Object {
	// /**
	//  * Creates a rich text element to show rich text. Eg. (Bold, Italic, Underline...)
	//  * rastwe: TODO: need some justification for having this here. Kendo editor?
	//  * @param {string} text - the text to display
	//  * @returns {Object} a rich text element to display
	//  * */
	// static createRichTextElement(text) {
	// 	/*why are we doing this? The text was created with Kendo which handles sanitizing. If you are showing
	// 	text that was not created with a kendo editor in rich text view, I dont know why you would, but use the below
	// 	function which seems useless as well. This will be removed soon.*/

	// 	/*const sanitizer = dompurify.sanitize;
	// 	text = sanitizer(_.unescape(text));*/
	// 	return <span dangerouslySetInnerHTML={Utility.createMarkup(text)} />;
	// }

	/**
	 * Get a sanitized text after parsing input for XSS.
	 * @param {string} text - the input text
	 * @param encode
	 * @param sanitizeOnUnEscape
	 * @returns {string} sanitized text
	 * */
	static getSanitizedText(text, {encode = true}, sanitizeOnUnEscape = true) {
		const sanitizer = dompurify.sanitize;
		let sanitizedText = '';
		if (sanitizeOnUnEscape) {
			const unescapeText = _.unescape(text);
			sanitizedText = sanitizer(unescapeText);
		} else {
			sanitizedText = _.unescape(sanitizer(text));
		}
		if (encode) {
			sanitizedText = encodeURIComponent(sanitizedText);
		}
		return sanitizedText;
	}

	/// Method to validate document
	/// file
	static ValidateDocument(file, documentSettingConfiguration) {
		if (file.size === 0) {
			return {
				code: 406,
				message: 'RequestEntityTooSmall'
			};
		}

		if (file.name.length > documentSettingConfiguration?.maxAllowedFileNameLength) {
			return {
				code: 414,
				message: 'RequestUriTooLong'
			};
		}

		if (file.size / 1048576 > documentSettingConfiguration?.uploadMaxAllowedEvidenceFileSize) {
			return {
				code: 413,
				message: 'RequestEntityTooLarge'
			};
		}

		// continue to upload
		return null;
	}

	/**
	 * Returns a value according to the user's preferences.
	 * @param {string} format - User format preference
	 * @param {string} value - Value to be formatted
	 * @returns {string} a formatted number.
	 * */
	static getFormattedNumber(format, value) {
		let selectedFormat = numberFormatsListItems[0].id;

		let userFormat = numberFormatsListItems.find((x) => x.id === format);
		if (userFormat) {
			selectedFormat = userFormat.id;
		}

		return numberFormattedText(selectedFormat, value);
	}

	/**
	 * Returns a value according to the user's preferences.
	 * @param userPreferences
	 * @param {string} value - Value to be formatted
	 * @returns {string} a formatted number.
	 * */
	static getNegativeFormattedNumber(userPreferences, value) {
		let preferences = JSON.parse(userPreferences.userPreferencesJson);
		let formatedText = value.replace('-', '');
		switch (preferences?.negativenumberformat) {
			case 0:
				return '(' + formatedText + ')';
			case 1:
				return '-' + formatedText;
			case 2:
				return '- ' + formatedText;
			case 3:
				return formatedText + '-';
			case 4:
				return formatedText + ' -';
			default:
				return '(' + formatedText + ')';
		}
	}

	static applyRounding = (value, decimals = 0) => {
		return applyRound(value, decimals);
	};

	static bigIntApplyRound(value) {
		let newValue = 0;
		if (value.toString().indexOf('.') !== -1) {
			let getDecimal = value.toString().indexOf('.');
			let actualVal = value.toString().split('.', 1);
			let decimalVal = Math.round(value.toString().substring(getDecimal));
			if (decimalVal > 0) {
				newValue =
					BigInt(actualVal) < 0 ? BigInt(actualVal) - BigInt(decimalVal) : BigInt(actualVal) + BigInt(decimalVal);
			} else {
				newValue = BigInt(actualVal);
			}
		} else {
			newValue = value;
		}
		return newValue;
	}

	static getInnerTextLengthFromRichText(html) {
		let element = document.createElement('div');
		element.innerHTML = html;
		// fix special chart from Kendo: &#65279
		return element.innerText.replace(/\uFEFF/g, '').trim().length;
	}

	static getInnerTextFromRichText(html) {
		let element = document.createElement('div');
		element.innerHTML = html;
		// fix special chart from Kendo: &#65279
		return element.innerText.replace(/\uFEFF/g, '').trim();
	}

	/**
	 * Private function to return html required for setting dangerous inner html
	 * @param {string} text - the text to display
	 * @returns {Object} an object with html set to the text passed in
	 * */
	static createMarkup(text) {
		const sanitizedText = Utility.getSanitizedText(text, {encode: false});
		return {__html: sanitizedText};
	}

	static getDocumentExtension(
		fileExt,
		hasComments,
		hasHiddenSheets,
		isConflicted,
		trackChange,
		isReturned,
		isReadOnly,
		isConfidential
	) {
		// ToDo: Need to discuss and change accordingly
		let fileIcon;
		let fileStatus = '-blank-small';
		if (fileExt === undefined || fileExt === null) {
			fileExt = '';
		}
		fileExt = fileExt.toString();
		if (fileExtensionMapping) {
			let mappedName = _.find(fileExtensionMapping.mapping, function(items) {
				return items.keys.indexOf(fileExt.toUpperCase()) >= 0;
			});

			if (mappedName) {
				fileIcon = mappedName.mapIconName;
			} else {
				fileIcon = 'unknown';
			}
		}

		// Set File status icon (as per priority)
		if (isConflicted) {
			fileStatus = '-conflicts-small';
		} else if (trackChange) {
			fileStatus = '-tracked-changes-small';
		} else if (hasComments) {
			fileStatus = '-comments-small';
		} else if (hasHiddenSheets) {
			fileStatus = '-hidden-sheets-small';
		} else if (isReturned) {
			fileStatus = '-returned-small';
		} else if (isReadOnly) {
			fileStatus = '-locked-small';
		} else if (isConfidential) {
			fileStatus = '-locked-small';
		} else {
		}

		return fileIcon + fileStatus;
	}

	static getRequestType(isExternalTask) {
		if (isExternalTask) {
			return relateRequestType.ET;
		}
		return relateRequestType.Request;
	}

	static GetRequestStatus(statusId, isProcessingError) {
		return isProcessingError
			? 'Processing Error'
			: !statusId
			? ''
			: currentResource.relatedItemStatus[statusId - 1].label;
	}
	/**
	 * Private function to return if a task type id is knowledge
	 * @param {number} taskTypeId - task type id
	 * @returns {boolean} if the task is knowledge
	 * */
	static isKnowledgeTask(taskTypeId) {
		return KnowledgeTaskTypes.some((type) => type === taskTypeId);
	}

	/**
	 * Private function to return if a task type id is group tasks excluding Component Group Task Unlinked
	 * @param {number} taskTypeId - task type id
	 * @returns {boolean} if the task is group tasks excluding Component Group Task Unlinked
	 * */
	static isGroupTaskExcludeUnlinked(taskTypeId) {
		return taskTypeId === TaskTypeEnum.PRIMARY_GROUP_TASK || taskTypeId === TaskTypeEnum.COMPONENT_GROUP_TASK;
	}

	/**
	 * Private function to return if a task type id is group tasks excluding Component Group Task Unlinked
	 * @param {number} taskTypeId - task type id
	 * @returns {boolean} if the task is a RT or ACT
	 * */
	static isTaskExcludeDelete(taskTypeId) {
		return (
			taskTypeId === TaskTypeEnum.PRIMARY_STANDARD_TASK ||
			taskTypeId === TaskTypeEnum.PRIMARY_SUBSTANTIVE_PROCEDURE_TASK ||
			taskTypeId === TaskTypeEnum.DEFICIENCY_RESPONSE_TASK ||
			taskTypeId === TaskTypeEnum.MISSTATEMENT_RESPONSE_TASK ||
			taskTypeId === TaskTypeEnum.ACCOUNT_CONCLUSION_TASK
		);
	}

	// Sort callback function for array of objects
	static compareValues(key, order = 'asc') {
		return function innerSort(a, b) {
			if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
				// property doesn't exist on either object
				return 0;
			}

			const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
			const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

			let comparison = 0;
			if (varA > varB) {
				comparison = 1;
			} else if (varA < varB) {
				comparison = -1;
			}
			return order === 'desc' ? comparison * -1 : comparison;
		};
	}

	/**
	 * Function that return the task type label.
	 * @param {string} typeTaskId - task type Id.
	 * @param {boolean} isEPSignoffRequired - flag is EP sign off requied.
	 * @param {boolean} isEQRSignoffRequired - flag is EQR sign off requied.
	 * @param {boolean} isEPSignoffUserRequired - flag is EP sign off user requied.
	 * @param {boolean} isEQRSignoffUserRequired - flag is EQR sign off user requied.
	 * @returns {string} task type label
	 * */
	static getTaskTypeLabel(
		typeTaskId,
		isEPSignoffRequired,
		isEQRSignoffRequired,
		isEPSignoffUserRequired,
		isEQRSignoffUserRequired
	) {
		let result = TaskType[typeTaskId - 1]
			? TaskType[typeTaskId - 1].taskAbbr
				? TaskType[typeTaskId - 1].taskAbbr
				: ' '
			: '';

		if (isEPSignoffRequired || isEQRSignoffRequired || isEPSignoffUserRequired || isEQRSignoffUserRequired) {
			result =
				(isEPSignoffRequired || isEPSignoffUserRequired) && (isEQRSignoffRequired || isEQRSignoffUserRequired)
					? labels.epeqr
					: isEPSignoffRequired || isEPSignoffUserRequired
					? labels.ep
					: labels.eqr;
		}

		return result;
	}

	static getTaskDocumentsApiUrl(inputData) {
		let url =
			env.getBaseURL(serviceURL, inputData.engagementId) +
			'Tasks/' +
			inputData.taskId +
			'/Documents?ReturnOnlyRelatedDocuments=true';

		if (inputData.workspaceId === undefined) {
			inputData.workspaceId = 0;
		}
		if (inputData.taskTypeId === undefined) {
			inputData.taskTypeId = 0;
		}

		if (inputData.queryStringInsert) {
			url =
				url +
				'&' +
				'workspaceid=' +
				inputData.workspaceId +
				'&' +
				'taskTypeId=' +
				inputData.taskTypeId +
				(inputData.returnTaskStatusAndFlagsOnly === true
					? '&' + 'returnTaskStatusAndFlagsOnly=' + inputData.returnTaskStatusAndFlagsOnly
					: '') +
				(inputData.isV2Return === true ? '&' + 'isV2Return=' + inputData.isV2Return : '');
		}
		return url;
	}

	static getRelatedObjectsApiUrl(taskId, engagementId, requestType) {
		let queryString = '';
		if (requestType === taskAttributes.relatedObjects) {
			queryString = '?IncludesRelatedObjects=true';
		} else {
			queryString = '?IncludesRelatedObjects=true&IncludesClientRequests=true&IncludesRelatedTasks=true';
		}

		return env.getBaseURL(serviceURL, engagementId) + 'Tasks/' + taskId + '/Components' + queryString;
	}

	static getDocumentChangeReasonApiUrl(engagementId, documentId) {
		return `${env.getBaseURL(serviceURL, engagementId)}documents/${documentId}/changereasons/`;
	}

	static getCanvasFormsReportApiUrl(engagementId) {
		return `${env.getBaseURL(serviceURL, engagementId)}documents?documentCategoryName=${
			documentCategoryNames.canvasForm
		}&pageSize=-1`;
	}

	/**
	 * Determines whether a text includes a certain value among its characters.
	 * @param  {String} source Text to be analized.
	 * @param  {String} target The text that could be included.
	 * @param normalizeNfd
	 * @return {boolean} A boolean indicating whether the second text is included or not.
	 */
	static isTextIncluded = (source, target, normalizeNfd = true) => {
		source = normalizeNfd ? this.normalizeNfd(source) : source;
		target = normalizeNfd ? this.normalizeNfd(target) : target;

		return source.includes(target);
	};

	/**
	 * Removes accent mark from a text.
	 * @param  {String} source Text to be cleaned.
	 */
	static normalizeNfd = (source) => {
		return source
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase();
	};

	/**
	 * Returns a boolean that determines if a change reason is required after uploading / editing a document.
	 * @param {object} engagement - Engagement object from the store.
	 * @param {object} quickLink - QuickLink object from the store.
	 * @param {object} document - Document data.
	 * */
	static isChangeReasonRequired(engagement, quickLink, document) {
		let changeReasonRequired = false;

		if (engagement.engagementStatusId !== EngagementStatus.Restored) {
			let currentDate = moment().utc(),
				engagementReportDate;

			// A change reason is required is the current date is after the report release date and the engagement has a 440GL document
			// and the document does not have a conflict.
			if (engagement && engagement.expectedReportReleaseDate) {
				engagementReportDate = moment.utc(engagement.expectedReportReleaseDate);
				const isConflicted = document && document.isConflicted;

				changeReasonRequired =
					!isConflicted && quickLink && quickLink.hasModificationsAfterRRD && currentDate.isAfter(engagementReportDate);
			}
		}

		return changeReasonRequired;
	}

	static getErrorMessageFromResponse(responseMessage, applyFontStyleOnErrorCode = false) {
		let error;
		let errorMessage = '';
		try {
			// responseMessage is an API middleware error object
			if (responseMessage.response && responseMessage.response.data && responseMessage.response.data.errors) {
				let errorList = responseMessage.response.data.errors;

				// TODO: Handle multiple error messages in the collection
				if (errorList.Error && Array.isArray(errorList.Error)) {
					errorMessage = errorList.Error[0];
					error = errorMessage.substr(0, errorMessage.indexOf(' -'));
				}
			} else if (responseMessage && responseMessage.indexOf(' - ') > 0) {
				/* errorMessage is a string with the following format: "errCode - errMessage" */
				errorMessage = responseMessage;
				error = errorMessage.substr(0, errorMessage.indexOf(' -'));
			}
		} catch (e) {
			errorMessage = responseMessage;
		}
		if (error && error.length > 0 && !Array.isArray(error)) {
			if (!error.ErrorCode) {
				const errorValue = Number(error);
				if (!isNaN(errorValue)) {
					return currentResource.Errors[errorValue]
						? applyFontStyleOnErrorCode
							? '<strong>' + error + ': ' + '</strong>' + currentResource.Errors[errorValue]
							: error + ': ' + currentResource.Errors[errorValue]
						: errorMessage;
				}
			}
		}
		return responseMessage;
	}

	/**
	 * forms canvas inCountry base url.
	 * @param engagementInformation
	 * */
	static getCanvasBaseWebUrl(engagementInformation) {
		let inCountryBaseUrl = env.getURL('eng_web');
		let engagementId = engagementInformation.engagementId || engagementInformation.id;
		let canvasUrl =
			inCountryBaseUrl +
			'/pages/index/index.html' +
			'?' +
			canvasUrlParams.countryid +
			'=' +
			engagementInformation.countryId +
			'&' +
			canvasUrlParams.engagementid +
			'=' +
			engagementId +
			'&' +
			canvasUrlParams.engagementdesc +
			'=' +
			encodeURIComponent(engagementInformation.engagementDescription?.substring(0, 50)) +
			'&' +
			canvasUrlParams.workspacedesc +
			'=' +
			encodeURIComponent(engagementInformation.workspaceDescription?.substring(0, 50)) +
			'&' +
			canvasUrlParams.workspaceid +
			'=' +
			engagementInformation.workspaceId +
			'&' +
			canvasUrlParams.isInterim +
			'=' +
			engagementInformation.isInterimEngagement +
			'&' +
			canvasUrlParams.engagementversion +
			'=' +
			engagementInformation.engagementVersion;

		return canvasUrl;
	}

	static getTaskUrl = (
		taskId,
		taskTypeId,
		engagementInformation,
		versionNumber = null,
		isV1Redirect = null,
		categoryId = OfflineTaskListFilters.categoryId,
		subCategoryId = OfflineTaskListFilters.subcategoryId
	) => {
		let url = '';
		let redirectToCanvas = false;
		if (versionNumber) {
			redirectToCanvas = versionNumber === 1;
		} else {
			redirectToCanvas = isV1Redirect || false;
		}
		if (redirectToCanvas) {
			url = this.getCanvasTaskDetailsWebUrl(canvasUrlParams.taskDetails, engagementInformation, taskId, taskTypeId);
		} else {
			url = `/${taskApiRoutes.task}${categoryId}/${subCategoryId}/${taskId.toLowerCase()}?engagementid=${
				engagementInformation.engagementId
			}`;
		}
		return url;
	};

	/**
	 * forms canvas inCountry url.
	 * @param {string} route - the route to add to canvas url
	 * @param engagementInformation
	 * @param routeData
	 * @returns {string} canvas inCountry url for the route
	 * */
	static getCanvasWebUrl(route, engagementInformation, routeData) {
		let inCountryBaseUrl = this.getCanvasBaseWebUrl(engagementInformation);

		let guidanceQueryStringData = '';
		if (routeData.guidanceLink) {
			guidanceQueryStringData =
				canvasUrlParams.standardId +
				'=' +
				routeData.standardId +
				'&' +
				canvasUrlParams.languageId +
				'=' +
				routeData.languageId +
				'&' +
				canvasUrlParams.formTypeId +
				'=' +
				routeData.formTypeId +
				'&';
		}

		let canvasUrl =
			inCountryBaseUrl +
			'&' +
			guidanceQueryStringData +
			(route === canvasUrlParams.addCanvasForm
				? canvasUrlParams.type + '=' + routeData.taskTypeId + '&'
				: route === canvasUrlParams.addFinding
				? canvasUrlParams.taskType + '=' + routeData.taskTypeId + '&'
				: '') +
			canvasUrlParams.returnUrl +
			'=' +
			routeData.currentRoute +
			canvasWebRoutes[route];

		return canvasUrl;
	}

	/**
	 * forms canvas collaboration client request detail URL.
	 * @param {number} clientRequestId - client request id
	 * @param {number} engagementId - engagement id
	 * @returns {string} canvas collaboration client request detail URL for the route
	 * */
	static getCanvasClientRequestDetailWebUrl(clientRequestId, engagementId) {
		return Utility.buildRequestsPath(
			collaborationFilterTypeEnum.allrequests,
			collaborationQuickFiltersTabsConstanst.all,
			clientRequestId,
			engagementId,
			defaultCurrentPage,
			defaultPageSize
		);
	}

	/**
	 * forms canvas inCountry url.
	 * @param {string} route - the route to add to canvas url
	 * @param {string} engagementInformation - engagement information
	 * @param {string} taskId - current route values. State values
	 * @param {number} taskTypeId - task type id
	 * @returns {string} canvas inCountry url for the route
	 * */
	static getCanvasTaskDetailsWebUrl(route, engagementInformation, taskId, taskTypeId) {
		let inCountryBaseUrl = env.getURL('eng_web');
		let engagementId = engagementInformation.engagementId || engagementInformation.id;

		return [
			inCountryBaseUrl,
			'/pages/index/index.html',
			'?',
			canvasUrlParams.countryid,
			'=',
			engagementInformation.countryId,
			'&',
			canvasUrlParams.engagementid,
			'=',
			engagementId,
			'&',
			canvasUrlParams.engagementdesc,
			'=',
			encodeURIComponent(engagementInformation.engagementDescription?.substring(0, 50)),
			'&',
			canvasUrlParams.workspacedesc,
			'=',
			encodeURIComponent(engagementInformation.workspaceDescription?.substring(0, 50)),
			'&',
			canvasUrlParams.workspaceid,
			'=',
			engagementInformation.workspaceId,
			'&',
			canvasUrlParams.engagementversion,
			'=',
			engagementInformation.engagementVersion,
			'&',
			canvasWebRoutes[route],
			'/',
			taskId,
			'/',
			taskTypeId
		].join('');
	}

	static getCanvasFindingWebUrl(route, engagementInformation, currentRoute, findingId, findingTypeId) {
		let inCountryBaseUrl = env.getURL('eng_web');
		let engagementId = engagementInformation.engagementId || engagementInformation.id;
		let canvasUrl =
			inCountryBaseUrl +
			'/pages/index/index.html' +
			'?' +
			canvasUrlParams.countryid +
			'=' +
			engagementInformation.countryId +
			'&' +
			canvasUrlParams.engagementid +
			'=' +
			engagementId +
			'&' +
			canvasUrlParams.engagementdesc +
			'=' +
			encodeURIComponent(engagementInformation.engagementDescription?.substring(0, 50)) +
			'&' +
			canvasUrlParams.workspacedesc +
			'=' +
			encodeURIComponent(engagementInformation.workspaceDescription?.substring(0, 50)) +
			'&' +
			canvasUrlParams.workspaceid +
			'=' +
			engagementInformation.workspaceId +
			'&' +
			canvasUrlParams.engagementversion +
			'=' +
			engagementInformation.engagementVersion +
			'&' +
			(findingTypeId === findingType.Deficiency
				? canvasUrlParams.deficiencyId + '=' + findingId + '&'
				: findingTypeId === findingType.Misstatement
				? canvasUrlParams.misstatementId + '=' + findingId + '&'
				: '') +
			canvasUrlParams.returnUrl +
			'=' +
			currentRoute +
			canvasWebRoutes[route];

		return canvasUrl;
	}

	/**
	 * forms canvas inCountry url.
	 * @param {string} route - the route to add to canvas url
	 * @param {object} engagementInformation - engagement information
	 * @param {string} currentRoute - current route
	 * @param {string} clientRequestId - optional related item id (Client Request or External Task)
	 * @param clientRequestGuid
	 * @param clientRequestStatusId
	 * @param isProcesingError
	 * @param clientRequestTypeId
	 * @param isClientRequest
	 * @returns {string} canvas inCountry url for the route
	 * */
	static getRelatedItemCanvasWebUrl(
		route,
		engagementInformation,
		currentRoute,
		clientRequestId,
		clientRequestGuid,
		clientRequestStatusId,
		isProcesingError,
		clientRequestTypeId,
		isClientRequest
	) {
		let inCountryBaseUrl = env.getURL('eng_web');
		let engagementId = engagementInformation.engagementId || engagementInformation.id;
		return (
			inCountryBaseUrl +
			'/pages/index/index.html' +
			'?' +
			canvasUrlParams.countryid +
			'=' +
			engagementInformation.countryId +
			'&' +
			canvasUrlParams.engagementid +
			'=' +
			engagementId +
			'&' +
			canvasUrlParams.engagementdesc +
			'=' +
			encodeURIComponent(engagementInformation.engagementDescription?.substring(0, 50)) +
			'&' +
			canvasUrlParams.cworkspacedesc +
			'=' +
			encodeURIComponent(engagementInformation.workspaceDescription?.substring(0, 50)) +
			'&' +
			canvasUrlParams.workspaceid +
			'=' +
			engagementInformation.workspaceId +
			'&' +
			canvasUrlParams.engagementversion +
			'=' +
			engagementInformation.engagementVersion +
			'&' +
			canvasUrlParams.clientRequestId +
			'=' +
			clientRequestId +
			'&' +
			canvasUrlParams.clientRequestGuid +
			'=' +
			clientRequestGuid +
			'&' +
			canvasUrlParams.clientRequestStatusId +
			'=' +
			clientRequestStatusId +
			'&' +
			canvasUrlParams.isRetry +
			'=' +
			isProcessingError +
			'&' +
			canvasUrlParams.isClientRequest +
			'=' +
			isClientRequest +
			'&' +
			canvasUrlParams.clientRequestTypeId +
			'=' +
			clientRequestTypeId +
			'&' +
			canvasUrlParams.returnUrl +
			'=' +
			currentRoute +
			canvasWebRoutes[route]
		);
	}

	/**
	 * forms canvas inCountry url.
	 * @param {object} engagementInformation - engagement information
	 * @param {string} clientRequestId - optional related item id (Client Request or External Task)
	 * @param {string} clientRequestGuid client request guid
	 * @param {int} clientRequestStatusId status id
	 * @param {bool} isProcessingError is procesing error
	 * @param {int} clientRequestTypeId request type id
	 * @param {bool} isClientRequest is client request
	 * @returns {string} canvas inCountry url for the route
	 * */
	static getRelatedItemCanvasWebUrlType2Request(
		engagementInformation,
		clientRequestId,
		clientRequestGuid,
		clientRequestStatusId,
		isProcessingError,
		clientRequestTypeId,
		isClientRequest
	) {
		let inCountryBaseUrl = env.getURL('eng_web');
		let engagementId = engagementInformation.engagementId || engagementInformation.id;
		return (
			inCountryBaseUrl +
			'/pages/index/index.html' +
			'?' +
			canvasUrlParams.countryid +
			'=' +
			engagementInformation.countryId +
			'&' +
			canvasUrlParams.engagementid +
			'=' +
			engagementId +
			'&' +
			canvasUrlParams.engagementdesc +
			'=' +
			encodeURIComponent(engagementInformation.engagementDescription?.substring(0, 50)) +
			'&' +
			canvasUrlParams.cworkspacedesc +
			'=' +
			encodeURIComponent(engagementInformation.workspaceDescription?.substring(0, 50)) +
			'&' +
			canvasUrlParams.workspaceid +
			'=' +
			engagementInformation.workspaceId +
			'&' +
			canvasUrlParams.engagementversion +
			'=' +
			engagementInformation.engagementVersion +
			'&' +
			canvasUrlParams.clientRequestId +
			'=' +
			clientRequestId +
			'&' +
			canvasUrlParams.clientRequestGuid +
			'=' +
			clientRequestGuid +
			'&' +
			canvasUrlParams.clientRequestStatusId +
			'=' +
			clientRequestStatusId +
			'&' +
			canvasUrlParams.isRetry +
			'=' +
			isProcesingError +
			'&' +
			canvasUrlParams.isClientRequest +
			'=' +
			isClientRequest +
			'&' +
			canvasUrlParams.clientRequestTypeId +
			'=' +
			clientRequestTypeId +
			'&' +
			'closeWindow' +
			'=' +
			'true' +
			'&' +
			'hashRoute' +
			'=' +
			'request'
		);
	}

	/**
	 *
	 * @param {int} clientRequestStatusId - Status Id of client request
	 * @returns true if status is in transit, false if not
	 */
	static isRequestStatusInTransit(clientRequestStatusId) {
		const transitStatusList = [
			ClientRequestStatus.SendInTransit,
			ClientRequestStatus.AcceptInTransit,
			ClientRequestStatus.WithdrawInTransit,
			ClientRequestStatus.DeleteInTransit,
			ClientRequestStatus.ReturnInTransit,
			ClientRequestStatus.ResponseInTransit,
			ClientRequestStatus.RecallInTransit,
			ClientRequestStatus.CompletionInTransit
		];
		return transitStatusList.includes(clientRequestStatusId);
	}

	static getAutomationLink = (engagement) => {
		return this.getCanvasBaseWebUrl(engagement) + '#automationhub';
	};

	static getCanvasBaseUrl = (engagement, displayLanguage) => {
		let curl = env.getURL('eng_web') + '/Pages/Index/index.html?';
		curl = `${curl}countryid=${engagement.countryId}&`;
		curl = `${curl}engagementid=${engagement.engagementId}&`;
		curl = engagement.clientid ? `${curl}clientid=${engagement.clientid}` : curl;
		curl = engagement.clientname ? `${curl}clientname=${encodeURIComponent(engagement.clientname)}` : curl;
		curl = `${curl}workspacedesc=${encodeURIComponent(engagement.workspaceDescription)}&`;
		curl = `${curl}workspaceid=${engagement.workspaceId}&`;
		curl = `${curl}userPrefLang=${displayLanguage ? displayLanguage : ''}&`;
		curl = `${curl}engagementversion=${engagement.engagementVersion}`;
		return curl;
	};

	static getArchiveOverrideShortcut = () => {
		return envConfig.archiveOverrideShortcut;
	};

	static getTimeoutOverrideValue = () => {
		return envConfig.timeoutOverrideValue;
	};

	static getComingDueDays = () => {
		return envConfig.comingDueDays;
	};

	static getComingDueDaysCollaborations = () => {
		return envConfig.comingDueDaysCollaboration;
	};

	static getAssignedToControlCacheTimeoutDurationInSeconds = () => {
		return envConfig.assignedToControlCacheTimeoutDurationInSeconds;
	};

	static getSubmitClientRequestSuccessMessageDisplayDuration = () => {
		return envConfig.submitClientRequestSuccessMessageDisplayDurationInMilliseconds;
	};

	static getAutomationHubLink = (baseCanvasUrl, engagement, engagementMetaData, isAutomationHubEnabled) => {
		if (isAutomationHubEnabled === false) {
			return baseCanvasUrl + '#automationhub';
		} else {
			if (engagementMetaData && engagementMetaData.length > 0) {
				const thisEngagement = engagementMetaData.find((emd) => emd.engagementid === engagement.engagementId);
				return `${env.getURL('Smart_Automation_Url')}?engagementid=${engagement.engagementId}&countryId=${
					engagement.countryId
				}&dataCenterId=${thisEngagement?.datacenterid}`;
			}
		}
	};

	static getServiceGatewayLink = (serviceGatewayBaseUrl, engagementId) => {
		if (serviceGatewayBaseUrl && engagementId) {
			return `${serviceGatewayBaseUrl}?engagementId=${engagementId}`;
		}
	};

	static getCentralizedServicesLabel = (serviceGatewayEnabled) => {
		return serviceGatewayEnabled ? labels.serviceGateway : labels.nextWaveservices;
	};

	static getServiceRequestsLabel = (serviceGatewayEnabled) => {
		return serviceGatewayEnabled ? labels.nextWaveServiceGatewayRequests : labels.nextWaveServiceRequests;
	};

	static getAutomationHubUrlFromFeature = (path = '', features) => {
		if (features?.eySmartAutomationBase) {
			return `${_.trimEnd(features?.eySmartAutomationBase, '/')}${path}`;
		} else {
			env.getSmartAutomationUrl(path);
		}
	};

	static getActivityFeedDurationInDays = () => {
		return envConfig.ActivityFeedDuration;
	};

	static getMaxFileNameAllowedValue = () => {
		return envConfig.MaxFileNameAllowed;
	};

	static getHideCanvasFormFromRelate = () => {
		return envConfig.hideCanvasFormFromRelate;
	};

	static isHelixProjectPartOfBlockedHelixSubscriptionIds = (subscriptionId) => {
		if (envConfig.blockedHelixSubscriptionIds) {
			var blockedSubscriptionIds = envConfig.blockedHelixSubscriptionIds.split(',');
			return blockedSubscriptionIds.includes(subscriptionId);
		}
		return false;
	};

	// Create query string
	static createQueryString(obj) {
		var params, i;

		params = [];
		for (i in obj) {
			if (obj.hasOwnProperty(i)) {
				params.push(i + '=' + encodeURIComponent(obj[i]));
			}
		}

		return params.join('&');
	}

	static isPaperProfile = (docType) => {
		return PaperProfileIds.includes(docType, 0);
	};

	static isProfileV2 = (docType) => {
		return docType === documentTypes.PROFILEV2;
	};

	static isFourForty = (docType) => {
		return docType === documentTypes.FOUR_FORTY_GL;
	};

	static isSmartForm = (docType) => {
		return SmartFormIds.includes(docType, 0);
	};

	static isGroupActivityDocumentList = (parentName) => {
		const groupActivityLists = [
			documentTabLayoutTabs.regionComponentName,
			documentTabLayoutTabs.activityFeed,
			documentTabLayoutTabs.activityFeedComponent
		];
		const parentNameSplit = parentName.split('_');
		return groupActivityLists.some((item) => parentNameSplit.includes(item));
	};

	static isCanvasForms = (document) => {
		const docType = document.docTypeId ? document.docTypeId : document.documentTypeId;
		let isCanvasForm = false;

		if (
			document.fileExt &&
			document.fileExt.toLowerCase() === 'smt' &&
			(SmartFormIds.includes(docType, 0) ||
				docType === documentTypes.PRIORYEAREVIDENCE ||
				CanvasFormsIds.includes(docType, 0))
		) {
			isCanvasForm = true;
		}

		return isCanvasForm;
	};

	static isAccountConclusion = (docType) => {
		return docType === documentTypes.ACCOUNTCONCLUSIONCLASSIC || docType === documentTypes.ACCOUNT_CONCLUSION;
	};

	static isDocumentOpenReadOnly = (documentTypeId) => ReadOnlyDocumentTypeIds.includes(documentTypeId);

	static isDocumentDisabledInV2 = (documentTypeId) => {
		return DisabledDocumentTypeIDs.includes(documentTypeId, 0);
	};

	static IsDocumentAllowedForDeletion = (documentTypeId) => {
		return DisabledDocumentTypeIDs.filter((documentTypeId) => !PaperProfileIds.includes(documentTypeId)).includes(
			documentTypeId,
			0
		);
	};

	static isSmartAutomationEvidence = (documentTypeId) => {
		return SmartAutomationEvidenceIds.includes(documentTypeId, 0);
	};

	static isDocumentEligibleToOpenInV1 = (documentTypeId) => {
		return OpenInCanvasDocumentTypeIDs.includes(documentTypeId, 0);
	};

	static getInstructionRouteUrl = (instruction) => {
		const herculesBaseWebUrl = _.trimEnd(env.getURL('hercules_web'), '/');
		const redirectWebUrl = `${herculesBaseWebUrl}/receiveinstructions?engagementid=${instruction.gaComponentEngagementId}&documentid=${instruction.documentId}`;
		return redirectWebUrl;
	};

	static getEntityUrlByCategory = (engagementId, category, entityuid) => {
		let categoryId = categoryMapping[category];
		switch (categoryId) {
			case TaskCategories.ExecutionAccounts:
				return `${env.getBaseURL(serviceURL, engagementId)}Accounts/${entityuid}/?${queryString.stringify({
					includeScots: true,
					includeAssertions: true,
					includeWCGWs: true,
					includeRelatedRisks: true,
					includeHelix: true,
					includeSEMSummary: true
				})}`;
			case TaskCategories.ExecutionSCOTs:
				return `${env.getBaseURL(serviceURL, engagementId)}Scots/${entityuid}/?${queryString.stringify({
					includeWCGW: true,
					includeControl: true,
					includeAccount: true,
					includeITProcess: true
				})}`;
			case TaskCategories.ExecutionITSOs:
				return `${env.getBaseURL(serviceURL, engagementId)}ITProcess/${entityuid}/?${queryString.stringify({
					includeSCOTs: true,
					includeITRisk: true,
					includeITControl: true
				})}`;
			case TaskCategories.Risks:
				return `${env.getBaseURL(serviceURL, engagementId)}Risks/${entityuid}/?${queryString.stringify({
					IncludeAssertions: true
				})}`;
			case TaskCategories.TaskSection:
				return `${env.getBaseURL(serviceURL, engagementId)}TaskSections/${entityuid}/`;
		}
	};

	static scrollToTop = (elementClassName) => {
		setTimeout(() => {
			const scrollElement = document.getElementsByClassName(elementClassName);
			if (_.size(scrollElement) > 0) {
				scrollElement[0]?.scrollIntoView({behavior: 'smooth'});
			}
		}, 250);
	};

	static getMaterialityUrl = (engagementId) => {
		return `${env.getBaseURL(serviceURL, engagementId)}Materiality`;
	};

	static getMestMaterialityUrl = (engagementId, stentities) => {
		//adjust to allow multiple entity ids when available.
		return `${env.getBaseURL(serviceURL, engagementId)}Materiality?sTEntityId=${stentities}`;
	};

	static getTaskGetAllUrlByCategoryAndEntityUID = (
		engagementId,
		categoryId,
		subcategoryId,
		highLevelFilters,
		qsParams,
		filter = {},
		searchstring = ''
	) => {
		let clone = {};
		let defaultFilterObj = {
			categoryId,
			subcategoryId,
			includeTaskList: true,
			includeAssignments: true,
			...highLevelFilters
		};
		defaultFilterObj =
			searchstring !== '' ? {...defaultFilterObj, searchString: searchstring.trim().toLowerCase()} : defaultFilterObj;
		clone = Object.assign(clone, defaultFilterObj);

		let newRenderFilters = {};
		let renderFilters = {...filter};

		$.each(renderFilters, function(key, value) {
			if (value === '' || value === null) {
				delete renderFilters[key];
			}
		});

		Object.entries(renderFilters).forEach((fil) => {
			newRenderFilters[fil[1].name] = fil[1].value;
		});

		if (renderFilters?.assignmentstatus?.value) {
			clone.assignmentstatus = [...renderFilters.assignmentstatus.value];
		}
		clone = this.removeDuplicateParamValues(clone);
		clone = {...qsParams, ...newRenderFilters, ...clone};

		let searchString = queryString.stringify({
			...clone
		});

		searchString = searchString
			.replaceAll('tag=%23', 'tag=')
			.replaceAll('assignedto=%23', 'assignedto=')
			.replaceAll('engagementUserRole=', 'assignedto=');

		return (
			env.getBaseURL(serviceURL, engagementId) +
			taskApiRoutes.task +
			'?' +
			searchString +
			'&orderBy=' +
			this.getDefaultOrderByField(defaultFilterObj.categoryId)
		);
	};

	static handleMestCategoryMapping = (category) => {
		switch (category) {
			case DrillDownCategories.all:
				return DrillDownMiscConstants.allTasks;
			case DrillDownCategories.scopestrategy:
			case DrillDownCategories.conclusion:
			case DrillDownCategories.execution:
				return DrillDownMiscConstants.taskSectionID;
			case DrillDownCategories.itprocess:
				return DrillDownMiscConstants.itso;
			default:
				return category;
		}
	};

	static handleFiltersOnStateUpdate = (bulkquickfilter, filterConfiguration) => {
		const filteredData = {};
		const quickfilterobj = bulkquickfilter;

		const setFilterData = (type, config, value) => {
			if (value && value.length > 0) {
				filteredData[type] = {
					...config,
					value: [...value]
				};
			}
		};

		const setDateFilterData = (type, config, value) => {
			if (value?.value) {
				filteredData[type] = {
					...config,
					value: value?.value
				};
			}
		};

		switch (quickfilterobj.type) {
			case QuickFilterActionTypes.taskstatus:
				setFilterData(QuickFilterTypes.taskstatus, filterConfiguration.menu[0].menu[0], quickfilterobj?.taskstatus);
				setFilterData(
					QuickFilterTypes.assignmentstatus,
					filterConfiguration.menu[1].menu[0],
					quickfilterobj?.assignmentStatus
				);
				setDateFilterData(
					QuickFilterTypes.filterduedatestart,
					filterConfiguration.menu[1].menu[4],
					quickfilterobj?.filterduedatestart
				);
				setDateFilterData(
					QuickFilterTypes.filterduedateend,
					filterConfiguration.menu[1].menu[3],
					quickfilterobj?.filterduedateend
				);
				break;
			case QuickFilterActionTypes.assignmentstatus:
				setFilterData(
					QuickFilterTypes.assignmentstatus,
					filterConfiguration.menu[1].menu[0],
					quickfilterobj?.assignmentStatus
				);
				setFilterData(QuickFilterTypes.taskstatus, filterConfiguration.menu[0].menu[0], quickfilterobj?.taskstatus);
				setDateFilterData(
					QuickFilterTypes.filterduedatestart,
					filterConfiguration.menu[1].menu[4],
					quickfilterobj?.filterduedatestart
				);
				setDateFilterData(
					QuickFilterTypes.filterduedateend,
					filterConfiguration.menu[1].menu[3],
					quickfilterobj?.filterduedateend
				);
				break;
			default:
				break;
		}

		return filteredData;
	};

	static handleMestCategoryForDocument = (category) => {
		switch (category) {
			case DrillDownCategories.scopestrategy:
			case DrillDownCategories.execution:
			case DrillDownCategories.conclusion:
				return DrillDownMiscConstants.tasksection;
			default:
				return category;
		}
	};

	static handleMestCategoryForSuggestedDocuments = (category) => {
		switch (category) {
			case DrillDownCategories.scopestrategy:
				return documentCategoryNames.ScopeStrategySuggested;
			case DrillDownCategories.execution:
				return documentCategoryNames.ExecutionSuggested;
			case DrillDownCategories.conclusion:
				return documentCategoryNames.ConclusionSuggested;
			case DrillDownCategories.account:
				return documentCategoryNames.AccountSuggested;
			case DrillDownCategories.scot:
				return documentCategoryNames.SCOTSuggested;
			case DrillDownCategories.itprocess:
				return documentCategoryNames.ITProcessSuggested;
			case DrillDownCategories.risk:
				return documentCategoryNames.RiskSuggested;
			default:
				return category;
		}
	};

	static getCanvasWebUrlForDocument = (document, engagementInformation, currentRoute, customProps = null) => {
		let engagementId = engagementInformation.engagementId || engagementInformation.id;
		let inCountryFullUrl = env.getURL('eng_web') + '/Pages/Index/index.html' + '?';
		let queryString =
			canvasUrlParams.countryid +
			'=' +
			engagementInformation.countryId +
			'&' +
			canvasUrlParams.engagementid +
			'=' +
			engagementId +
			'&' +
			canvasUrlParams.engagementdesc +
			'=' +
			encodeURIComponent(engagementInformation.engagementDescription?.substring(0, 50)) +
			'&' +
			canvasUrlParams.workspacedesc +
			'=' +
			encodeURIComponent(engagementInformation.workspaceDescription?.substring(0, 50)) +
			'&' +
			canvasUrlParams.workspaceid +
			'=' +
			engagementInformation.workspaceId +
			'&' +
			canvasUrlParams.engagementversion +
			'=' +
			engagementInformation.engagementVersion +
			'&' +
			canvasUrlParams.returnUrl +
			'=' +
			currentRoute;

		let documentTypeId = document.docTypeId ? document.docTypeId : document.documentTypeId;
		if (documentTypeId && GuidedWorkflowV2DocumentTypes.includes(documentTypeId)) {
			return env.getKronosUrl(`fit?engagementid=${engagementId}&documentid=${document.id}`);
		}

		switch (documentTypeId) {
			case documentTypes.PROFILE: {
				return inCountryFullUrl + queryString + '#engagementprofile/' + document.id + '/' + documentTypeId;
			}
			case documentTypes.ACCOUNTSSUMMARY: {
				return inCountryFullUrl + queryString + '#accountsummary';
			}
			case documentTypes.SCOTSSUMMARY: {
				return inCountryFullUrl + queryString + '#scotsummary';
			}
			case documentTypes.ITSOSUMMARY: {
				return inCountryFullUrl + queryString + '#itsummary';
			}
			case documentTypes.CRASUMMARY: {
				return inCountryFullUrl + queryString + '#crasummary';
			}
			case documentTypes.AUDITPLAN: {
				return inCountryFullUrl + queryString + '#plan';
			}
			case documentTypes.GROUPAUDITSTRUCTURESUMMARY: {
				return inCountryFullUrl + queryString + '#groupauditstructuresummary';
			}
			case documentTypes.GROUPAUDITINSTRUCTIONSUMMARY: {
				return inCountryFullUrl + queryString + '#groupauditinstructionsummary';
			}
			case documentTypes.GROUPCOMPONENTSUMMARYDOCUMENT: {
				const herculesBaseWebUrl = _.trimEnd(env.getURL('hercules_web'), '/');
				const redirectWebUrl =
					herculesBaseWebUrl + '/receiveinstructions?engagementid=' + engagementId + '&documentid=' + document.id;
				return redirectWebUrl;
			}
			case documentTypes.WORKPLANSUMMARY: {
				return inCountryFullUrl + queryString + '#plan';
			}
			case documentTypes.ITEVALUATIONSMARTFORM: {
				return inCountryFullUrl + queryString + '#itevaluation/' + document.id;
			}
			case documentTypes.ITEVALUATIONTEMPORARYSMARTFORM: {
				return inCountryFullUrl + queryString + '#itevaluation/' + document.id;
			}
			case documentTypes.CANVASFORMTEMPORARY:
			case documentTypes.CANVASFORMEVIDENCE: {
				return env.getKronosUrl(`canvasform?engagementid=${engagementId}&documentid=${document.id}`);
			}
			case documentTypes.PROFILEV2: {
				return env.getKronosUrl(`fit/${document.id}?engagementid=${engagementId}`);
			}
			case documentTypes.INDEPENDENCEFORMTEMPLATE: {
				/*return inCountryFullUrl + queryString + '#independenceconfirmations';*/
				return (
					window.location.origin + `/smartscreens/independence?engagementid=${engagementId}&documentid=${document.id}`
				);
			}
			case documentTypes.ACCOUNTCONCLUSIONCLASSIC: {
				return inCountryFullUrl + queryString + '#accountconclusion/' + document.id + '/' + documentTypeId;
			}
			case documentTypes.ARCHIVE: {
				return inCountryFullUrl + queryString + '#archive/' + document.id + '/' + documentTypeId;
			}
			case documentTypes.SEM: {
				return window.location.origin + '/smartscreens/sem?engagementid=' + engagementId + '&documentid=' + document.id;
			}
			case documentTypes.GUIDEDWORKFLOW:
			case documentTypes.CONTROL_UNDERSTAND_CONTROLS_TEMPORARY:
			case documentTypes.CONTROL_UNDERSTAND_CONTROLS:
			case documentTypes.CONTROL_TEST_CONTROL_ATTRIBUTES:
			case documentTypes.CONTROL_TEST_CONTROL_ATTRIBUTES_TEMPORARY:
			case documentTypes.SCOT_WALKTHROUGH:
			case documentTypes.SCOT_WALKTHROUGH_TEMPORARY:
			case documentTypes.GUIDEDWORKFLOWV2:
			case documentTypes.GUIDEDWORKFLOWTEMPORARY: {
				return env.getKronosUrl(`fit?engagementid=${engagementId}&documentid=${document.id}`);
			}
			case documentTypes.FOUR_FORTY_GL: {
				return (
					window.location.origin + '/smartscreens/440gl?engagementid=' + engagementId + '&documentid=' + document.id
				);
			}
			case documentTypes.GROUPSUMMARY: {
				return window.location.origin + `/groupsummary?engagementid=${engagementId}&documentid=${document.id}`;
			}
			case documentTypes.SMARTAUTOMATIONEVIDENCE:
			case documentTypes.SMARTAUTOMATIONEVIDENCETEMPORARY: {
				return this.getAutomationHubUrlFromFeature(
					`?engagementid=${engagementId}&countryId=${engagementInformation.countryId}&dataCenterId=${customProps?.datacenterid}&requestid=${document.smartEvidenceSourceId}`,
					customProps.features
				);
			}
			default:
				return '';
		}
	};

	static isRenameOpenable(engagementId, engagementStatusId, engagementSourceId, document) {
		const [isOpenable] = this.getDocumentIsOpenable(
			{engagementId, engagementStatusId, engagementSourceId},
			undefined,
			document,
			true
		);
		return isOpenable;
	}

	static isDocumentOptionEnable(
		menuItem,
		{engagementId, engagementStatusId, engagementSourceId},
		userConfidentialityTypeId,
		parentName,
		document,
		itemState,
		appOnlineState,
		documentTasks
	) {
		if (!parentName) parentName = document.parentName;
		if (!itemState) itemState = {isProcessing: false};
		const [isOpenable] = this.getDocumentIsOpenable(
			{engagementId, engagementStatusId, engagementSourceId},
			userConfidentialityTypeId,
			document
		);
		if (engagementId !== document.engagementId && !isOpenable) {
			return false;
		}

		switch (menuItem) {
			case 'Open': {
				let result = false;
				if (
					isOpenable &&
					document.fileExt &&
					!document.fileExt.toLowerCase().startsWith('zip') &&
					!this.isDocumentDisabledInV2(document.documentTypeId) &&
					!this.isDocumentOpenReadOnly(document.documentTypeId) &&
					!(!appOnlineState && document.fileExt.toLowerCase() === 'smt') &&
					!this.isDaasDocumentCheckInCheckOutInProgress(document)
				) {
					result = true;
				}
				return result;
			}
			case 'Start Co-edit mode':
				return (
					!this.isDocumentEligibleForDaaSCheckedOut(document?.documentStatusId, document?.contentContractId) &&
					!this.isDaasDocumentCheckInCheckOutInProgress(document) &&
					!document?.isConflicted
				);
			case 'End Co-edit mode':
				return (
					this.isDocumentEligibleForDaaSCheckedIn(document?.documentStatusId, document?.contentContractId) &&
					(!this.isDaaSDocumentCheckOutComplete(document) ||
						!this.isDaasDocumentCheckInCheckOutInProgress(document) ||
						!this.isDaaSDocumentCheckInError(document))
				);
			case 'Open read-only':
				if (
					isOpenable &&
					// document.fileExt !== '' condition is related to isPaperProfile condition
					!this.isPaperProfile(document.documentTypeId) &&
					!this.isSmartForm(document.documentTypeId) &&
					!this.isCanvasForms(document) &&
					!this.isDocumentDisabledInV2(document.documentTypeId) &&
					!this.isAccountConclusion(document.documentTypeId) &&
					!this.isDocumentEligibleToOpenInV1(document.documentTypeId) &&
					!this.isSmartAutomationEvidence(document.documentTypeId) &&
					!this.isDaaSDocumentCheckOutComplete(document) &&
					!this.isDaasDocumentCheckInCheckOutInProgress(document) &&
					!this.isDaaSDocumentCheckInError(document)
				) {
					return true;
				} else return false;
			case 'View history':
				if (
					// document.fileExt !== '' condition is related to isPaperProfile condition
					document.fileExt !== '' &&
					!this.isPaperProfile(document.documentTypeId) &&
					!this.isSmartForm(document.documentTypeId) &&
					!this.isCanvasForms(document) &&
					!this.isDocumentDisabledInV2(document.documentTypeId) &&
					!this.isDocumentOpenReadOnly(document.documentTypeId) &&
					!this.isAccountConclusion(document.documentTypeId) &&
					!this.isSmartAutomationEvidence(document.documentTypeId) &&
					!this.isIndependenceConfirmation(document.documentTypeId) &&
					!this.isFourForty(document.documentTypeId) &&
					!this.isProfileV2(document.documentTypeId)
				) {
					return true;
				} else return false;
			case 'Rename':
				if (
					(this.isRenameOpenable(engagementId, engagementStatusId, engagementSourceId, document) &&
						!this.isDocumentOpenReadOnly(document.documentTypeId)) ||
					this.isDocumentAlwaysRenamable(document.documentTypeId)
				) {
					return true;
				}
				return false;
			case 'Delete':
				if (
					!document.hasAnySystemAssociated &&
					!document.isShared &&
					!this.IsDocumentAllowedForDeletion(document.documentTypeId) &&
					!this.getDocumentIsRestricted(engagementStatusId, engagementSourceId, document.fileExt) &&
					this.isConfidentialByUserConfidentialtyType(document.confidentialityTypeId, userConfidentialityTypeId) &&
					!this.isDocumentOpenReadOnly(document.documentTypeId) &&
					!this.isGroupActivityDocumentList(parentName) &&
					!this.isDaaSDocumentCheckOutComplete(document) &&
					!this.isDaasDocumentCheckInCheckOutInProgress(document) &&
					!this.isDaaSDocumentCheckInError(document)
				) {
					return true;
				} else return false;
			case 'RelateTasks': {
				return !(
					document.documentTypeId === documentTypes.GROUPCOMPONENTINSTRUCTIONDOCUMENT ||
					document.documentTypeId === documentTypes.RETURNEDDOCUMENT
				);
			}
			case 'RelateEntities':
				if (
					document.documentTypeId === documentTypes.GROUPCOMPONENTINSTRUCTIONDOCUMENT ||
					document.documentTypeId === documentTypes.RETURNEDDOCUMENT
				) {
					return false;
				}
				if (document.smartEvidenceSourceEntityId || document.hasAnySystemAssociated === true) {
					return false;
				} else {
					return true;
				}

			//#region Additional menu options
			// Add additional menu options starting here (No parentName check required since those parents inyect this options)
			case 'Remove from task':
				if (!document.hasTaskSystemAssociated && !this.isGroupActivityDocumentList(parentName)) {
					return true;
				} else return false;

			case 'Unlink':
				if (document.isShared && !itemState.isProcessing) {
					return true;
				} else return false;
			case 'Restore':
				return true;
			case 'PermanentlyDelete':
				return true;
			case 'ChangeReason':
				return true;
			case 'CopyLink':
				return parentName !== documentTabLayoutTabs.myPinnedDocuments;
			case 'Confidentiality':
				return (
					document.engagementId === engagementId &&
					(document.documentTypeId === documentTypes.EVIDENCE ||
						document.documentTypeId === documentTypes.CRASH ||
						document.documentTypeId === documentTypes.PRIORYEAREVIDENCE ||
						document.documentTypeId === documentTypes.CLIENTFILES ||
						document.documentTypeId === documentTypes.EYSENTTOCLIENTFILES ||
						document.documentTypeId === documentTypes.AUTOMATIONHUBINPUT ||
						document.documentTypeId === documentTypes.AUTOMATIONHUBOUTPUT ||
						document.documentTypeId === documentTypes.AUTOMATIONHUBCLIENTINPUT ||
						document.documentTypeId === documentTypes.AUTOMATIONHUBCLIENTOUTPUT) &&
					!this.isDaaSDocumentCheckOutComplete(document) &&
					!this.isDaasDocumentCheckInCheckOutInProgress(document) &&
					!this.isDaaSDocumentCheckInError(document)
				);
			case 'AssignRegionComponent':
				return true;
			case 'UnassignRegionComponent':
				return true;
			case 'ReturnToRegionComponent':
				return document.gaLinkStatusID === GALinkStatus.Accepted && document.documentTypeId === documentTypes.EVIDENCE;
			case 'ClearReturnToRegionComponent':
				return true;
			case 'OverwriteForm':
				return true;
			case 'Finalize':
				return true;
			case 'SignoffRequirements':
				return !this.isPaperProfile(document.documentTypeId);
			//#endregion

			default:
				return false;
		}
	}

	static getDocumentIdFromUrl(thisComponent) {
		let queryStringParams = queryString.parse(thisComponent.props.history.location.search.toLowerCase());
		return queryStringParams.documentid;
	}

	static getEngagementIdFromUrl() {
		let queryStringParams = queryString.parse(location.search.toLowerCase());
		let engId = queryStringParams.engagementid;

		// If the engagementId is sent multiple times in the url, keep the first one
		let engagementId = engId;
		if (engId && (Array.isArray(engId) || engId.indexOf(',') >= 0)) {
			engagementId = Array.isArray(engId) ? engId[0] : engId.split(',')[0];
			if (engagementId.indexOf(',') >= 0) {
				engagementId = engagementId.split(',')[0];
			}
		}

		return engagementId;
	}

	static getTrialBalanceIdFromUrl() {
		let queryStringParams = queryString.parse(location.search.toLowerCase());
		return queryStringParams.trialbalanceid;
	}

	static getRelativeDate(date) {
		const DIVISIONS = [
			{amount: 7, name: labels.daysAgo},
			{amount: 4.34524, name: labels.weeksAgo},
			{amount: 12, name: labels.monthsAgo},
			{amount: Number.POSITIVE_INFINITY, name: labels.yearsAgo}
		];

		let duration = Math.round((Date.now() - new Date(date).getTime()) / (1000 * 3600 * 24));

		for (let i = 0; i <= DIVISIONS.length; i++) {
			const division = DIVISIONS[i];

			if (duration < division.amount) {
				if (division.name === labels.daysAgo) {
					switch (duration) {
						case 0:
							return labels.today;
						case 1:
							return labels.yesterday;
						default:
							return `${duration} ${labels.daysAgo}`;
					}
				}

				if (division.name === labels.weeksAgo) {
					if (Math.trunc(duration) === 1) {
						return `1 ${labels.weekAgo}`;
					}

					return `${Math.trunc(duration)} ${labels.weeksAgo}`;
				}

				if (division.name === labels.monthsAgo) {
					if (Math.trunc(duration) === 1) {
						return `1 ${labels.monthAgo}`;
					}

					return `${Math.trunc(duration)} ${labels.monthsAgo}`;
				}

				if (division.name === labels.yearsAgo) {
					if (Math.trunc(duration) === 1) {
						return `1 ${labels.yearAgo}`;
					}

					return `${Math.trunc(duration)} ${labels.yearsAgo}`;
				}
			}

			duration /= division.amount;
		}
	}

	static sortAlphaNumeric(arr = [], sortKey) {
		const compareAlphaNumeric = (a, b) => {
			let valueA = a[sortKey];
			let valueB = b[sortKey];

			// Both values are strings. Compare them in a case-insensitive manner.
			if (typeof valueA === 'string' && typeof valueB === 'string') {
				valueA = valueA.toLowerCase();
				valueB = valueB.toLowerCase();
			}

			if (valueA > valueB) return 1;
			if (valueA < valueB) return -1;
			return 0;
		};
		const compareNumeric = (a, b) => {
			if (a > b) return 1;
			if (a < b) return -1;
			return 0;
		};
		arr.sort(sortKey ? compareAlphaNumeric : compareNumeric);
	}

	static getAnnotationUrlByCategory(categoryId, annotationId, entityId) {
		let result = '';
		if (entityId) {
			result += (categoryId === entities.Document ? '&documentId=' : '&taskId=') + entityId;
		}
		if (annotationId) {
			result +=
				categoryId === entities.CanvasForm ? '&engagementCommentID=' + annotationId : '&annotationId=' + annotationId;
		}
		return result;
	}

	static getAnnotationsUrl(
		annotationId,
		entityId,
		engagementId,
		categoryId,
		returnsOnlyCount,
		includeAnnotationList,
		includeAnnotationReplies,
		annotationStatusIds,
		assignedTo,
		authoredBy,
		search,
		orderBy,
		pageSize,
		showAuthorAndAssigned,
		engagementSource = 1
	) {
		let optionalParamsQuery = '';
		if (search) {
			optionalParamsQuery += '&searchString=' + encodeURIComponent(search);
		}
		if (orderBy) {
			optionalParamsQuery += '&sortOrder=' + orderBy;
		}
		if (pageSize) {
			optionalParamsQuery += '&pageSize=' + pageSize;
		}
		if (assignedTo && !_.isEmpty(assignedTo)) {
			optionalParamsQuery += assignedTo.map((item) => `&reviewNotesAssignedTo=${item}`).join('');
		}
		if (authoredBy && !_.isEmpty(authoredBy)) {
			optionalParamsQuery += authoredBy.map((item) => `&reviewNotesAuthoredBy=${item}`).join('');
		}
		if (annotationStatusIds && !_.isEmpty(annotationStatusIds)) {
			optionalParamsQuery += annotationStatusIds.map((item) => `&annotationStatusIds=${item}`).join('');
		}
		if (showAuthorAndAssigned) {
			optionalParamsQuery += '&showAuthorAndAssigned=' + showAuthorAndAssigned;
		}
		return (
			env.getBaseURL(serviceURL, engagementId) +
			'Annotations/?categoryId=' +
			categoryId +
			this.getAnnotationUrlByCategory(categoryId, annotationId, entityId) +
			'&returnsOnlyCount=' +
			returnsOnlyCount +
			'&includeAnnotationList=' +
			includeAnnotationList +
			'&includeAnnotationReplies=' +
			includeAnnotationReplies +
			'&engagementSource=' +
			engagementSource +
			optionalParamsQuery
		);
	}

	static isIndependenceConfirmation(documentTypeId) {
		return documentTypes.INDEPENDENCEFORMTEMPLATE === documentTypeId;
	}

	static getIndependenceConfirmationUrl(documentId, engagementId) {
		return `${smartScreenRoutes.independence}?engagementId=${engagementId}&documentid=${documentId}`;
	}

	static getKronosDocumentUrl(engagementId, documentId) {
		return env.getKronosUrl(`fit?engagementId=${engagementId}&documentId=${documentId}`);
	}

	static getEngagementUsersUrl(engagementId, userStatus) {
		let optionalParams = '';

		if (userStatus && !_.isEmpty(userStatus)) {
			optionalParams += userStatus.map((item) => `&userStatus=${item}`).join('');
		}

		let returnValue = env.getBaseURL(serviceURL, engagementId) + 'Users';

		if (optionalParams) {
			returnValue += '?' + optionalParams.substring(1); //removing first & to make adding params easier
		}

		return returnValue;
	}

	/**
	 * RNH Get entity id from path name.
	 * @param {string} categoryText - path name
	 * @returns {number} entity id
	 * */
	static getEntityIdFromUrl(categoryText) {
		if (categoryText) {
			let path = reviewNoteRoutes.path[categoryText.toLowerCase()];

			if (path) {
				return path.id;
			}
		}

		return reviewNoteRoutes.path.all.id;
	}

	/**
	 * RNH Get path name from entity id.
	 * @param {string} entityId - entity id
	 * @returns {string} path name
	 * */
	static getPathFromEntityId(entityId) {
		let path = '';
		Object.entries(reviewNoteRoutes.path).forEach(([_, value]) => {
			if (value.id === entityId) {
				path = value.path;
			}
		});

		return path;
	}

	static GetDocHelperStateKey(documentList, keyToSearch) {
		let keys = [];
		//Get all keys which mach with given key passed so that we can update the state
		_.map(documentList, function(value, key) {
			if (key.indexOf(keyToSearch) === 0) {
				keys.push(key);
			}
		});

		return keys;
	}

	static getDateFormatWithoutYear = (dateFormat) => {
		let result = dateFormat;
		const regExp = '(^/)*([/yY]{5})|($/)w+';
		let capture = result.match(regExp);
		if (capture !== null && capture.length > 0) {
			result = result.replace(capture[0], '');
		}
		return result;
	};

	static displayTeamMember = (displayFullname, roleId) => {
		let localizedRoleName = '';
		if (!displayFullname.trim()) {
			const roleList = currentResource.RoleForMember;
			_.each(roleList, function(obj) {
				if (obj.id === roleId) {
					localizedRoleName = obj.role;
				}
			});
			return localizedRoleName;
		}
		return displayFullname;
	};

	static getRoleNameForMember = (roleId) => {
		let role = currentResource.RoleForMember.find((r) => r.id === roleId);

		return _.isUndefined(role) ? 'N/A' : role.role;
	};

	static getRoleForMember = (roleId) => {
		let role = currentResource.RoleForMember.find((r) => r.id === roleId);

		return _.isUndefined(role) ? 'N/A' : role;
	};

	static sortByDueDays = (a, b) => {
		if (a.dueDays > b.dueDays) {
			return -1;
		}
		if (a.dueDays < b.dueDays) {
			return 1;
		}
		return 0;
	};

	static getDefaultOrderByField = (categoryId) => {
		const taskNameCategories = [4, 5, 6, 10];
		const knowledgeCategories = [3, 7, 8, 11];
		if (taskNameCategories.includes(Number(categoryId), 0)) {
			return TaskListSortFields.TaskName;
		}

		if (knowledgeCategories.includes(Number(categoryId), 0)) {
			return TaskListSortFields.Knowledge;
		}

		return TaskListSortFields.DueDate;
	};

	//Return the status code.
	static getStatusCode = (result) => {
		return result?.response?.data?.status;
	};

	//Return the error message from the object of the API.Error number optional.
	static getErrorMessage = (result) => {
		let displayError = this.getValidationMessage(result, 'Error');
		displayError ||= this.getValidationMessage(result, 'Body');
		displayError ||= this.getValidationMessage(result, 'HasScopeRequirement');

		return displayError;
	};

	//Return the error message from the object of the API validation error.
	static getValidationMessage = (result, propertyName) => {
		let displayError =
			result &&
			result.response &&
			result.response.data &&
			result.response.data.errors &&
			result.response.data.errors[propertyName] &&
			result.response.data.errors[propertyName]?.length > 0 &&
			result.response.data.errors[propertyName][0];

		return displayError ?? '';
	};
	static openDocumentForEditing = (payload) => {
		console.log('Opening Document 📃✔✔✔✔✔');

		let _connectionID;

		if (window.jQuery.connection && window.jQuery.connection[env.getDocHelperConfig().hubName]) {
			_connectionID = window.jQuery.connection[env.getDocHelperConfig().hubName].connection.id;
		}

		let payloadData = {
			...payload.payloadData,
			connectionId: _connectionID || undefined
		};

		let url = {
			openDocument: true,
			fileId: payloadData.documentId,
			docTypeId: payloadData.docTypeId,
			engagementId: payloadData.engagementId,
			docUrl: env.getDocServiceUrl(),
			resourceUri: env.getURL('Engg_AuthAudience_URL'),
			readonly: payload.actionTag === 'openr',
			includeDeleted: payload.includeDeleted
		};

		if (payloadData.fileVersion) {
			url.fileVersion = payloadData.fileVersion;
		}

		let docHelperUri = env.getDocHelperConfig().docHelperApiUri + 'Document' + '?' + Utility.createQueryString(url);
		let openPromise;
		if (
			!_connectionID &&
			!isNullOrUndefined(payloadData.engagementStatusId) &&
			payloadData.engagementStatusId !== EngagementStatus.CanvasExternalAccessPortalV2
		) {
			// Through docHelper error if no connection available to DocHelper
			console.log('No Connection to DocHelper Available');
			openPromise = payload.actions.raiseDochelperError([
				'0010',
				'Connection Failed',
				payload.labels.documentHelperConnectionIssue
			]);
			return;
		}
		try {
			openPromise = payload.actions
				.downloadDocumentWithDocumentHelper(docHelperUri, payloadData, {
					connectionid: payloadData.connectionId
				})
				.then((response) => {
					try {
						if (!(response && response.data)) {
							return;
						}
						let filename = '';
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;

						let disposition = response.headers['content-disposition'];
						if (disposition && disposition.toLowerCase().indexOf('attachment') !== -1) {
							const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
							const matches = filenameRegex.exec(disposition);
							if (matches !== null && matches[1]) {
								try {
									filename = decodeURIComponent(matches[1].replace(/['"]/g, ''));
								} catch (err) {
									filename = matches[1].replace(/['"]/g, '');
								}
							}
						}

						// need to figure out file name on download
						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();
					} catch (err) {
						console.log('Unable to download document from DocService.');
					}
				});
		} catch (e) {
			console.log('No Connection to DocHelper Available');
			openPromise = payload.actions.raiseDochelperError([
				'0010',
				'Connection Failed',
				payload.labels.documentHelperConnectionIssue
			]);
		}

		return openPromise;
	};

	static openDocument = (
		engagementId,
		documentId,
		documentName,
		fileExt,
		documentTypeId,
		documentTypeName,
		versionNumber,
		actionTag,
		onDocumentDownload,
		onDocumentError,
		isBulkOpen,
		engagementStatusId
	) => {
		let payload = {
			payloadData: {
				documentHubStatus: 'DOWNLOADSTART',
				parentName: documentTypeName,
				documentId: documentId,
				documentName: documentName + '.' + fileExt,
				docTypeId: documentTypeId,
				transactionId: documentId,
				documentType: documentTypeId,
				ProgressPercent: 0,
				totalPercentage: 100,
				inProgress: true,
				engagementId: engagementId,
				engagementStatusId: engagementStatusId,
				dockey: `_${documentId}`,
				fileVersion: versionNumber ? versionNumber : null,
				isBulkOpen
			},
			actions: {
				downloadDocumentWithDocumentHelper: onDocumentDownload,
				raiseDochelperError: onDocumentError
			},
			actionTag: actionTag,
			labels: {
				documentHelperConnectionIssue: labels.documentHelperConnectionIssue
			}
		};

		return this.openDocumentForEditing(payload);
	};

	static getDocKey = (param) => {
		let key = '';
		let seprator = '_';
		if (param.documentId === undefined) {
			return key;
		}
		if (param.documentId) {
			key = key + seprator + param.documentId;
		}
		//    if(param.parentName){
		// 	  key = key + seprator + param.parentName;
		//    }
		if (param.taskId) {
			key = key + seprator + param.taskId;
		}
		if (param.version) {
			key = key + seprator + param.version;
		}
		return key;
	};

	static getDocumentListKey = (parentName, documentId) => {
		// TODO: Using a hash function would be better
		let result = documentId;
		if (parentName) {
			result = `${parentName}_${documentId}`;
		}
		return result;
	};

	/// get parent name to show progress bar only selected tab's document
	static getParentNameForSelectedTab = (parentName) => {
		// return if parentname is undefined
		if (!parentName) return;
		let getParentName = parentName.split('_');
		if (getParentName && getParentName.length > 0 && getParentName[1] !== undefined) {
			return getParentName[1];
		}

		return parentName;
	};

	static getDocumentHelperKey = (documentId, documentName, fileExt) => {
		let result = `${documentName}${fileExt ? `.${fileExt}` : ''}`;
		if (documentId) {
			result += `_${documentId}`;
		}

		return result;
	};

	static findEditNoteLayoutOpen = (param) => {
		let editOpen = document.querySelector('#edit-reviewnote-layout') === null;
		if (!editOpen && param && param.scrollToElement) {
			// If edit note window is open
			document.querySelector('#edit-reviewnote-layout').scrollIntoView();
		}

		let addOpened = document.querySelector('#add-reviewnote-layout') === null;
		if (!addOpened && param && param.scrollToElement) {
			// If add note window is open
			document.querySelector('#add-reviewnote-layout').scrollIntoView();
			return addOpened;
		}
		return editOpen;
	};

	static getDatesForSelectedFilter = (selectedFilter, startDateKey, endDateKey, dateFormat) => {
		let dueDateFilter = {};
		switch (selectedFilter) {
			case 'currentDate': {
				dueDateFilter[endDateKey] = moment.utc().format(dateFormat);
				break;
			}
			case 'currentWeek': {
				dueDateFilter[startDateKey] = moment()
					.day('Sunday')
					.utc()
					.format(dateFormat);
				dueDateFilter[endDateKey] = moment()
					.day('Sunday')
					.add(6, 'days')
					.utc()
					.format(dateFormat);
				break;
			}
		}
		return dueDateFilter;
	};

	static isNewView = (clientYearEndDate) => {
		return moment(clientYearEndDate, 'YYYY/MM/DD').isAfter(new Date('2025/12/14'));
	};

	static drilldownURL = (engagementId, category, view, entityuid) => {
		return `/dashboard?engagementid=${engagementId}&category=${category}&entityUID=${entityuid}&view=${view}#engagementOverview`;
	};

	static getTaskListRefreshUrl = (taskListFilters, engagementId, payload) => {
		let nonMenuFilters = {...taskListFilters};
		delete nonMenuFilters[`${engagementId}#tasks`];
		let menuFilters = {...taskListFilters[`${engagementId}#tasks`]};

		let renderFilters = {...nonMenuFilters, ...menuFilters};

		// If due date is applied through quick filter, update the dates for API filters
		if (renderFilters['assignmentDueDate']) {
			const dueDateFilter = this.getDatesForSelectedFilter(
				renderFilters['assignmentDueDate'][0],
				'filterDueDateStart',
				'filterDueDateEnd',
				'YYYY-MM-DD'
			);
			delete renderFilters['assignmentDueDate'];
			renderFilters = {...renderFilters, ...dueDateFilter};
		}

		$.each(renderFilters, function(key, value) {
			if (value === '' || value === null) {
				delete renderFilters[key];
			}
		});

		let clone = renderFilters;

		if (payload) {
			clone = Object.assign(clone, payload);
		}
		// This line is commented to resolve defect #990326.
		// delete clone.orderBy;
		delete clone.quickFilterId;
		clone = this.removeDuplicateParamValues(clone);

		let searchString = queryString.stringify({
			...clone
		});

		searchString = searchString.replaceAll('tag=%23', 'tag=').replaceAll('assignedto=%23', 'assignedto=');
		let requestsUrl =
			env.getBaseURL(serviceURL, engagementId) +
			taskApiRoutes.task +
			'?' +
			searchString +
			'&orderBy=' +
			(renderFilters.orderBy === undefined
				? this.getDefaultOrderByField(renderFilters.categoryId)
				: renderFilters.orderBy);

		return requestsUrl;
	};

	// Removes duplicate integer values from task list filters
	static removeDuplicateParamValues = (queryStringParamsObject) => {
		let queryStringParams = _.cloneDeep(queryStringParamsObject);
		for (let param in queryStringParams) {
			if (Array.isArray(queryStringParams[param])) {
				let occurrences = {};
				let valueArray = queryStringParams[param];
				for (let p = 0; p < valueArray.length; p++) {
					if (occurrences.hasOwnProperty(valueArray[p])) {
						occurrences[`${valueArray[p]}`] += 1;
					} else occurrences[`${valueArray[p]}`] = 1;
				}
				for (let count in occurrences) {
					if (occurrences[count] > 1) {
						const index = queryStringParams[param].indexOf(+count);
						if (index !== -1) {
							queryStringParams[param].splice(index, 1);
						}
					}
				}
			}
		}
		return queryStringParams;
	};

	static getBulkTaskListRefreshUrl = (taskListFilters, engagementId, filterKey, payload, ispictaskview = false) => {
		let nonMenuFilters = {...taskListFilters};
		delete nonMenuFilters[filterKey];
		let menuFilters = {...taskListFilters[filterKey]};

		let renderFilters = {...nonMenuFilters, ...menuFilters};

		// If due date is applied through quick filter, update the dates for API filters
		if (renderFilters['assignmentDueDate']) {
			const dueDateFilter = this.getDatesForSelectedFilter(
				renderFilters['assignmentDueDate'][0],
				'filterDueDateStart',
				'filterDueDateEnd',
				'YYYY-MM-DD'
			);
			delete renderFilters['assignmentDueDate'];
			renderFilters = {...renderFilters, ...dueDateFilter};
		}

		$.each(renderFilters, function(key, value) {
			if (value === '' || value === null) {
				delete renderFilters[key];
			}
		});

		let clone = renderFilters;

		if (payload) {
			clone = Object.assign(clone, payload);
		}
		// This line is commented to resolve defect #990326.
		// delete clone.orderBy;
		delete clone.quickFilterId;
		if (ispictaskview && !_.isUndefined(clone.searchType)) {
			clone = {
				...clone,
				searchType:
					clone.searchType === documentGetAllParamNames.contains ? SearchTypes.contains : SearchTypes.startsWith
			};
		}
		clone = this.removeDuplicateParamValues(clone);
		let searchString = queryString.stringify({
			...clone
		});

		searchString = searchString.replaceAll('tag=%23', 'tag=').replaceAll('assignedto=%23', 'assignedto=');
		let requestsUrl =
			env.getBaseURL(serviceURL, engagementId) +
			taskApiRoutes.task +
			'?' +
			searchString +
			'&orderBy=' +
			(renderFilters.orderBy === undefined
				? this.getDefaultOrderByField(renderFilters.categoryId)
				: renderFilters.orderBy);

		return requestsUrl;
	};

	static isClientRequestOrExternalTaskInTransit = (statusId) => {
		const InTransitStatusIds = [11, 12, 13, 14, 15, 19, 21];
		if (InTransitStatusIds.includes(statusId, 0)) {
			return true;
		}

		return false;
	};

	/**
	 * Private function to return engagement id from store or query string
	 * @param {object} engagement - engagement from store
	 * @param {object} search - search string from location.search
	 * @returns {any} engagement id
	 * */
	static getEngagementId(engagement, search) {
		if (engagement && engagement.engagementId) {
			return engagement.engagementId;
		}
		if (search) {
			let query = queryString.parse(search.toLowerCase());
			return query.engagementid || '';
		}
		return '';
	}

	static getAssignmentNameById = (id) => {
		let result = '';
		let label = currentResource.assignmentTypeLabels.find((assignment) => assignment.id === id);

		if (label) {
			result = label.label;
		}

		return result;
	};

	// This function can be used to get localized text
	static getLocalizedText(localizedData, input) {
		let attrbuteText = input.attrbuteText;
		let object = localizedData.find((r) => r.id === input.attributeId);
		if (object && input.attributeName) {
			attrbuteText = object[input.attributeName];
		}

		return attrbuteText ? attrbuteText : input.attrbuteText;
	}

	/**
	 * Return the current date in ISOS format, example: 2020-06-01T15:26:23.620Z.
	 * @returns {string} current date in YYYY-MM-DDTHH:mm:ss.sm.
	 * */
	static getCurrentDate() {
		return new Date().toISOString();
	}

	/**
	 * Creates a rich text element to show rich text. Eg. (Bold, Italic, Underline...)
	 * rastwe: TODO: need some justification for having this here. Kendo editor?
	 * @param {string} text - the text to display
	 * @param styleName
	 * @param onClick
	 * @returns {Object} a rich text element to display
	 * */
	static createRichTextElement(text, styleName, onClick) {
		/*why are we doing this? The text was created with Kendo which handles sanitizing. If you are showing
		text that was not created with a kendo editor in rich text view, I dont know why you would, but use the below
		function which seems useless as well. This will be removed soon.*/

		/*const sanitizer = dompurify.sanitize;
		text = sanitizer(_.unescape(text));*/
		return (
			<span
				onClick={(e) => {
					onClick && onClick(e);
				}}
				className={styleName ?? ''}
				dangerouslySetInnerHTML={Utility.createMarkup(text)}
			/>
		);
	}

	/**
	 * Creates a rich text element to show labels with links added in between.
	 * @returns {Object} a rich text element to display
	 * @param label
	 * @param btnReplaceObj
	 * */
	static renderPlaceholderLabelWithClickableLinks(label, btnReplaceObj) {
		return label.split(/(\{\d+\})/).map((segment, index) => {
			if (/\{\d+\}/.test(segment)) {
				return (
					<MotifButton
						key={index}
						variant="text-alt"
						size="small"
						className={btnReplaceObj[segment]?.btnClass}
						onClick={btnReplaceObj[segment]?.btnClick}
					>
						{btnReplaceObj[segment]?.btnLabel}
					</MotifButton>
				);
			}
			return segment;
		});
	}

	/**
	 * Return the current date format based in user preferences.
	 * @param {object} userPreferences - userPreferences from store
	 * @returns {string} current date format.
	 * */
	static getUserPreferencesDateFormat(userPreferences) {
		let dateFormat = dateFormats[defaultDateFormat] && dateFormats[defaultDateFormat].format;
		if (userPreferences.isPreferencesLoaded) {
			dateFormat = dateFormats[userPreferences.dateFormat] && dateFormats[userPreferences.dateFormat].format;
		}
		return dateFormat;
	}

	/**
	 * Return the current date format based in user preferences.
	 * @param {object} userPreferences - userPreferences from store
	 * @param dateFormat
	 * @param useUserPreferences
	 * @returns {string} current date format.
	 * */
	static getUserPreferencesDateLabel(userPreferences, dateFormat = defaultDateFormat, useUserPreferences = true) {
		let dateTimeFormat = dateFormats[dateFormat] && dateFormats[dateFormat].label;
		if (useUserPreferences && userPreferences.isPreferencesLoaded) {
			dateTimeFormat = dateFormats[userPreferences.dateFormat] && dateFormats[userPreferences.dateFormat].label;
		}
		return dateTimeFormat;
	}

	/**
	 * Return the current date time format based in user preferences.
	 * @param {object} userPreferences - userPreferences from store
	 * @param dateFormat
	 * @param useUserPreferences
	 * @returns {string} current date time format.
	 * */
	static getUserPreferencesDateTimeLabel(userPreferences, dateFormat = defaultDateFormat, useUserPreferences = true) {
		let dateTimeFormat = dateTimeFormats[dateFormat] && dateTimeFormats[dateFormat].label;
		if (useUserPreferences && userPreferences.isPreferencesLoaded) {
			dateTimeFormat = dateTimeFormats[userPreferences.dateFormat] && dateTimeFormats[userPreferences.dateFormat].label;
		}
		return dateTimeFormat;
	}

	static convertUTCDateToLocalDate(date) {
		let newDate = new Date(date.getTime() - date.getTimeZoneOffset() * 60 * 1000);
		return newDate;
	}

	static formatTimeWithAmPm(dateParam) {
		let newDate = new Date(dateParam);
		let date = new Date(newDate.getTime() - newDate.getTimezoneOffset() * 60 * 1000);
		let hours = date.getHours();
		let minutes = date.getMinutes();
		const ampm = hours >= 12 ? 'PM' : 'AM';
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		minutes = minutes < 10 ? '0' + minutes : minutes;
		return hours + ':' + minutes + ' ' + ampm;
	}

	static getDatePartsBasedOnFormat(userPreferences, dateString) {
		const format = Utility.getUserPreferencesDateLabel(userPreferences);
		let result = [];
		let dateParts = dateString.split('/');
		switch (format) {
			case 'MM/DD/YYYY': {
				result[0] = Number(dateParts[2]);
				result[1] = Number(dateParts[0]) - 1;
				result[2] = Number(dateParts[1]);
				break;
			}
			case 'DD/MM/YYYY': {
				result[0] = Number(dateParts[2]);
				result[1] = Number(dateParts[1]) - 1;
				result[2] = Number(dateParts[0]);
				break;
			}
			case 'YYYY/MM/DD': {
				result[0] = Number(dateParts[0]);
				result[1] = Number(dateParts[1]) - 1;
				result[2] = Number(dateParts[2]);
				break;
			}
		}
		return result;
	}

	/**
	 * Private function to return flag to identify value is modified
	 * @param {object} originalValue - original value of the item/property
	 * @param {object} modifiedValue - modified/updated value of the item/property
	 * @returns {boolean} isValueModified
	 * */
	static isValueModified(originalValue, modifiedValue) {
		if (
			modifiedValue !== undefined &&
			modifiedValue !== null &&
			modifiedValue !== '' &&
			modifiedValue !== originalValue
		) {
			return true;
		}

		return false;
	}

	/**
	 * return new value if is not equial to original or default value
	 * @param {object} originalValue - original value
	 * @param {object} newValue - modified/updated value
	 * @returns {boolean} getNewValueIfUpdated
	 * */
	static getNewValueIfUpdated(originalValue, newValue, defaultValue = '') {
		return originalValue === newValue ? defaultValue : newValue;
	}

	/**
	 * sort an array by given keys.
	 * @param {Array} toSort - the array to sort.
	 * @returns {any} the sortedArray
	 * */
	static sortByMultipleKey(toSort) {
		let key = '';

		// check if toSort is array
		if (Array.isArray(toSort)) {
			if (toSort.length === 0) return 0;
			key = toSort[0];
		} else {
			key = toSort;
		}

		return function(a, b) {
			// nulls sort after anything else
			if (a[key] === null) {
				return 1;
			} else if (b[key] === null) {
				return -1;
			}
			// otherwise, if we're ascending, lowest sorts first
			else if (a[key] < b[key]) {
				return -1;
			}
			// if descending, highest sorts first
			else if (a[key] > b[key]) {
				return 1;
			}
			// equal items sort equally
			else {
				if (toSort.slice(1).length > 0) {
					return Utility.sortByMultipleKey(toSort.slice(1))(a, b);
				} else return 0;
			}
		};
	}

	/**
	 * Get the review note status name
	 * @param {number} statusId - the statusId to filter.
	 * @returns {string} the status name
	 * */
	static getNoteStatusName(statusId) {
		let result = '';
		if (statusId && statusId > 0) {
			result = _.capitalize(currentResource.reviewStatus.find((x) => x.id === statusId).name);
		}
		return result;
	}

	/**
	 * update Document Route
	 * @param {string} documentTab.
	 * @returns {Object} props
	 * */
	static updateDocumentRoute(documentTab, props) {
		// get location url
		const locationUrl = props.location && props.location.search ? props.location.search : window.location.search;

		let parsed = queryString.parse(locationUrl);
		parsed.viewdocumenttab = documentTab;

		let search = queryString.stringify(parsed);

		props.history.replace({
			pathname: props.history.pathname,
			search: search.toLowerCase(),
			hash: props.history.location.hash
		});
	}

	/**
	 * Build the URL with the engagementId, path and paramters.
	 * @param {object} engagementId - engagementId.
	 * @param {string} path - path or rout of the URL.
	 * @param {object} parameters - parameters to make the get call. (Optional)
	 * @returns {string} complete URL to make the call.
	 * */
	static getURLWithParameters = (engagementId, path, parameters) => {
		let url = new URL(`${env.getBaseURL(serviceURL, Number(engagementId))}` + path);

		if (parameters) {
			Object.entries(parameters).forEach((parameter) => {
				if (parameter[1]) {
					url.searchParams.append(parameter[0], parameter[1]);
				}
			});
		}

		return url.toString();
	};

	/**
	 * Build the URL with the engagementId, path and paramters.
	 * @param {object} engagement - engagement object.
	 * @param {object} locationSearch - search property from props.history.location.
	 * @param {string} path - path or rout of the URL.
	 * @param {object} filters - parameters to make the get call. (Optional)
	 * @returns {string} complete URL to make the call.
	 * */
	static concatenateURL = (engagement, locationSearch, path, filters) => {
		let url = new URL(`${env.getBaseURL(serviceURL, this.getEngagementId(engagement, locationSearch))}` + path);

		if (filters) {
			Object.entries(filters).forEach((filter) => {
				if (filter[1]) {
					url.searchParams.append(filter[0], filter[1]);
				}
			});
		}

		return url.toString();
	};

	/**
	 * Validates if the str is a valid URL
	 * @param {string} str - string to validate.
	 * * */
	static validURL = (str) => {
		const pattern = new RegExp(
			'^(https?:\\/\\/)?' + // protocol
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
			'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
			'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
				'(\\#[-a-z\\d_]*)?$',
			'i'
		); // fragment locator
		return !!pattern.test(str);
	};

	/**
	 * Returns true if the engagement is a "Review" type engagement.
	 * @param {object} engagement - engagement object from state - API response -.
	 * @returns Whether the engagement is a "Review" type engagement.
	 */
	static isReviewTypeEngagement = (engagement) => {
		return engagement.isReviewTypeEngagement;
	};

	/**
	 * If the client year end date falls before December 15, 2023, then the user should NOT see the ISA 220 validations on the archive checklist.
	 * Otherwise, the user should see the ISA 220 validation on the archive checklist.
	 * @param {object} engagement - engagement object from state - API response -.
	 * @returns {boolean} Whether the user should see ISA 220 validations.
	 */
	static showISA220Validations = (engagement) => {
		const isa220validationsDate = new Date(ISA220ValidationsDate);
		const clientYearEndDate = new Date(engagement?.clientYearEndDate);

		return clientYearEndDate.getTime() >= isa220validationsDate.getTime();
	};

	/**
	 * Returns true if EQR sign off is required for the engagement.
	 * @param {object} engagement - engagement object from state - API response -.
	 * @returns {boolean} Whether EQR sign off is required for the engagement.
	 */
	static isEngagementEQRrequired = (engagement) => {
		return !!engagement?.isEQRSignoffRequired;
	};

	/**
	 * Return a flag if a validation type must be display in archive page.
	 * @param {object} quickLink - QuickLink object from state - API response-.
	 * @param {number} validationType - ArcTimelineTypes object from ui constant.
	 * @param {number} count - Display the item based on count.
	 * @param {object} engagement - Engagement object from state.
	 * @returns {boolean} If the item must be display for the current engagement.
	 * */
	static displayTypeItem = (quickLink, validationType, count, engagement) => {
		// Finalize evidence section - ISA 220 validations.
		if (validationType.groupId === ValidationGroup.ArchiveTimelineFinalizeEvidence) {
			if (
				validationType.id === ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask ||
				validationType.id === ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements
			) {
				return !this.isReviewTypeEngagement(engagement) && this.showISA220Validations(engagement);
			}

			if (
				validationType.id === ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask ||
				validationType.id === ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements
			) {
				return (
					this.isEngagementEQRrequired(engagement) &&
					!this.isReviewTypeEngagement(engagement) &&
					this.showISA220Validations(engagement)
				);
			}

			if (
				validationType.id === ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly ||
				validationType.id === ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge
			) {
				return this.isEngagementEQRrequired(engagement);
			}

			if (
				validationType.id === ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject &&
				(count === undefined || count === 0)
			) {
				return false;
			}
		}

		// Complete Remaining Tasks section - ISA 220 validations.
		if (validationType.groupId === ValidationGroup.ArchiveTimelineCompleteRemainingTasks) {
			if (validationType.id === ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence) {
				return !this.isReviewTypeEngagement(engagement) && this.showISA220Validations(engagement);
			}

			if (validationType.id === ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence) {
				return (
					this.isEngagementEQRrequired(engagement) &&
					!this.isReviewTypeEngagement(engagement) &&
					this.showISA220Validations(engagement)
				);
			}

			if (validationType.id === ArcTimeLineValidationTypes.RelateEvidenceToEntityTask) {
				return engagement.isMestEngagement;
			}
		}

		if (validationType.groupId === ValidationGroup.ArchiveTimelineResolveValidations) {
			// Engagement has account summary and ALRA Doc Id is null.
			if (validationType.id === ArcTimeLineValidationTypes.AccountsSummary) {
				if (
					quickLink?.hasAccountSummary == true &&
					(quickLink?.accountLevelRiskAssessmentDocumentId === null ||
						quickLink?.accountLevelRiskAssessmentDocumentId === undefined)
				) {
					return true;
				}
				return false;
			}

			if (validationType.id === ArcTimeLineValidationTypes.AdjustmentsModule) {
				if (engagement?.isHelixDataImportAllowed) {
					return true;
				}
				return false;
			}
		}

		if (validationType?.displayAlways === COUNT) return !!parseInt(count);

		if (validationType?.displayAlways) return validationType.displayAlways;

		// Exceptional rule. When the IT Flow is present we don't show the IT Summary
		if (quickLink && validationType.id === ArcTimeLineValidationTypes.ITSummary) {
			if (Boolean(quickLink[validationType?.quickLinkFlag]) && Boolean(quickLink.hasITFlowISA315)) {
				return quickLink[validationType?.quickLinkFlag] && !quickLink.hasITFlowISA315;
			}
		}

		if (validationType && quickLink && Boolean(quickLink[validationType.quickLinkFlag]))
			return quickLink[validationType.quickLinkFlag];

		return false;
	};

	/**
	 * Calculate the total and complete validation items for a group validation.
	 * @param {Array} types - array of validation types.
	 * @param {Object} quickLink - quickLink object from state - API response-.
	 * @param {Integer} groupId - group id value.
	 * @param engagement
	 * @returns {Array} Return the total and completed items for a group validation.
	 * */
	static calculatePercent = (types, quickLink, groupId, engagement) => {
		let total = 0;
		let typesLength = types?.length ?? 0;

		const arcItems = ArcTimelineTypes.filter((x) => x.groupId === groupId);
		for (let i = 0; i < arcItems.length; i++) {
			if (
				this.displayTypeItem(
					quickLink,
					arcItems[i],
					types?.find((t) => t.validationsubgroupid === arcItems[i].id)?.validationcount,
					engagement
				)
			) {
				total += 1;
			} else {
				// Finalize evidence section.
				if (groupId === ValidationGroup.ArchiveTimelineFinalizeEvidence) {
					const validationSubgroupIds = [
						ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
						ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
						ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
						ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
						ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
						ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
						ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject
					];

					for (let j = 0; j < types?.length; j++) {
						if (
							arcItems[i].id === types[j].validationsubgroupid &&
							validationSubgroupIds.includes(types[j].validationsubgroupid)
						) {
							typesLength--;
						}
					}
				}

				// Complete Remaining Tasks section.
				if (groupId === ValidationGroup.ArchiveTimelineCompleteRemainingTasks) {
					for (let j = 0; j < types?.length; j++) {
						if (
							arcItems[i].id === types[j].validationsubgroupid &&
							types[j].validationsubgroupid === ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence
						) {
							typesLength--;
						}

						if (
							arcItems[i].id === types[j].validationsubgroupid &&
							types[j].validationsubgroupid === ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence
						) {
							typesLength--;
						}
					}
				}

				// Resolve remaining validations section.
				if (groupId === ValidationGroup.ArchiveTimelineResolveValidations) {
					const validationSubgroupIds = [
						ArcTimeLineValidationTypes.AccountsSummary,
						ArcTimeLineValidationTypes.AdjustmentsModule
					];
					for (let j = 0; j < types?.length; j++) {
						if (
							arcItems[i].id === types[j].validationsubgroupid &&
							validationSubgroupIds.includes(types[j].validationsubgroupid)
						) {
							typesLength--;
						}
					}
				}
			}
		}

		return [total - typesLength, total];
	};

	/**
	 * Return a flag if a validation type must be display.
	 * @param {object} engagement - quickLink object from state.
	 * @param {number} typeId - quickLink object from state.
	 * @returns {boolean} If must be display for the current engagement.
	 * */
	static displayCheckLisItem = (engagement, typeId) => {
		const checkType = ArcCheckLstTypesObject[typeId];

		if (checkType && checkType.display) return checkType.display;

		if (engagement && Boolean(engagement[checkType.flag])) return engagement[checkType.flag];

		if (
			typeId === ArcTimeLineValidationTypes.PersonInCharge &&
			![
				EngagementSource.CEAPortalV2,
				EngagementSource.CanvasExternalAccessPortalV2,
				EngagementSource.CopyEngagementReviewOnly
			].includes(engagement.engagementSourceId)
		)
			return true;

		return false;
	};

	static isArcCheckListChecked = (typeId, arcChecksList, engagementMetaData, engagement) => {
		switch (typeId) {
			case ArcCheckLstTypes.AccuracyEngagementDates:
				return (
					arcChecksList &&
					arcChecksList.engagementDatesModel &&
					arcChecksList.engagementDatesModel.checklistModel &&
					arcChecksList.engagementDatesModel.checklistModel.isChecked
				);
			case ArcCheckLstTypes.AccuracyClientCodes:
				const invalidCode =
					engagementMetaData &&
					engagementMetaData.find((item) => {
						return item.engagementid === engagement.engagementId;
					})?.clientcode === invalidClientCode;

				if (invalidCode) {
					return false;
				}
				return arcChecksList && arcChecksList.clientCodeModel && arcChecksList.clientCodeModel.isChecked;
			case ArcCheckLstTypes.AccuracyEngagementCodes:
				if (arcChecksList?.engagementCodesModel?.clientEngagementCodes?.find((eng) => !eng.isValid)) {
					return false;
				}
				return (
					arcChecksList &&
					arcChecksList.engagementCodesModel &&
					arcChecksList.engagementCodesModel.checklistModel &&
					arcChecksList.engagementCodesModel.checklistModel.isChecked
				);
			case ArcCheckLstTypes.ReportType:
				return (
					arcChecksList &&
					arcChecksList.reportTypeModel &&
					arcChecksList.reportTypeModel.checklistModel &&
					arcChecksList.reportTypeModel.checklistModel.isChecked
				);
			case ArcCheckLstTypes.EngagementProfileSubmit:
				return arcChecksList && arcChecksList.profileChecklistModel && arcChecksList.profileChecklistModel.isChecked;
			case ArcCheckLstTypes.UnlinkGroupEvidence:
				return (
					arcChecksList && arcChecksList.unlinkGroupEvidenceModel && arcChecksList.unlinkGroupEvidenceModel.isChecked
				);
			case ArcCheckLstTypes.FinalizedHardEvidence:
				return (
					arcChecksList &&
					arcChecksList.finalizedHardEvidenceModel &&
					arcChecksList.finalizedHardEvidenceModel.checklistModel &&
					arcChecksList.finalizedHardEvidenceModel.checklistModel.isChecked
				);
			case ArcCheckLstTypes.ReviewProtectedDocuments:
				return (
					arcChecksList && arcChecksList.protectedDocumentsModel && arcChecksList.protectedDocumentsModel.isChecked
				);
			case ArcCheckLstTypes.ReviewTemporaryFilesModifiedAfterRRD:
				return (
					arcChecksList &&
					arcChecksList.reviewTemporaryFilesModifiedAfterRRDModel &&
					arcChecksList.reviewTemporaryFilesModifiedAfterRRDModel.isChecked
				);
			case ArcCheckLstTypes.ReviewDeletedFilesModifiedAfterRRD:
				return (
					arcChecksList &&
					arcChecksList.reviewDeletedFilesModifiedAfterRRDModel &&
					arcChecksList.reviewDeletedFilesModifiedAfterRRDModel.isChecked
				);
			case ArcCheckLstTypes.UnlinkSharedEvidence:
				//For business logic validation will be always true.
				return true;
			case ArcCheckLstTypes.PersonInCharge:
				return arcChecksList?.personInCharge?.isChecked;
			default:
				return false;
		}
	};

	/**
	 * Calculate the total and complete validation items for a group validation.
	 * @param {Array} types - array of validation types.
	 * @param {Object} engagement - quickLink object from state.
	 * @param {Object} checksList - quickLink object from state.
	 * @param engagementMetaData
	 * @returns {Array} Return the total and completed items for a group validation.
	 * */
	static calculatePercentCheck = (types, engagement, checksList, engagementMetaData) => {
		let completed = 0;
		let total = 0;

		if (types && types.length > 0) {
			for (let i = 0; i < types.length; i++) {
				if (this.displayCheckLisItem(engagement, types[i])) {
					total += 1;
					if (this.isArcCheckListChecked(types[i], checksList, engagementMetaData, engagement)) completed += 1;
				}
			}
		}

		return [completed, total];
	};

	static normalize = (field, accumulator, key) => {
		let result;

		// If an accumulator is passed, the result should be at least, that
		if (accumulator) {
			result = {
				byId: {...accumulator.byId},
				allIds: [...accumulator.allIds]
			};
		}

		// If field was correctly passed and result is still undefined, initialize it
		if (!result) {
			result = {
				byId: {},
				allIds: []
			};
		}

		// Run array normalization logic
		if (Array.isArray(field)) {
			for (let k = 0; k < field.length; k++) {
				const entity = field[k];

				const index = key ? entity[key] : entity?.id;
				result.byId[index] = entity;
				result.allIds.push(index);
			}
		}

		return result;
	};

	static useFetch = (fetch, cacheKey, cleanup = undefined) => {
		const [isLoading, setIsLoading] = useState(
			// Fetch might no be defined for fixed data components
			fetch &&
				// and if defined, it must be a function
				typeof fetch === 'function' &&
				// If a cacheKey is specified, check if the cache expired
				(!cacheKey || (cacheKey && this.cacheTimedOut(cacheKey)))
				? true
				: false
		);

		useEffect(() => {
			if (isLoading) {
				fetch()
					.then(() => cacheKey && sessionStorage.setItem(cacheKey, new Date()))
					.catch((error) => {
						throw error;
					})
					.finally(() => {
						setIsLoading(false);
					});
			}

			if (cleanup) {
				return cleanup;
			}
		}, []);

		return [isLoading, setIsLoading];
	};

	static useCacheContext = (cacheKeyCollection, clearOnNavigationType = performance.navigation.TYPE_RELOAD) => {
		if (!Array.isArray(cacheKeyCollection)) {
			throw 'cacheKeyCollection parameter must be an array of cacheKeys as string values.';
		}

		useEffect(() => {
			if (window.performance) {
				switch (performance.navigation.type) {
					case clearOnNavigationType:
						for (let i = 0; i < cacheKeyCollection.length; i++) {
							sessionStorage.removeItem(cacheKeyCollection[i]);
						}
						break;

					default:
						break;
				}
			} else {
				throw 'performance API support not available.';
			}
		}, []);
	};

	static cacheTimedOut(cacheKey) {
		let result = true;
		if (cacheKey) {
			const current = new Date().getTime();
			const cache = new Date(sessionStorage.getItem(cacheKey)).getTime();

			// TODO: Put 300 value in a constant or some configurable value
			const timeout = 300 * 1000;

			if (current - cache <= timeout) {
				result = false;
			}
		}

		return result;
	}

	//TODO: We should add LanguageCode property in UserPreferences endpoint so we can properly map locales against Moment
	static getLocale(userPreferences) {
		let result = '';
		if (userPreferences) {
			result = userPreferences.displayLanguage;
			switch (userPreferences.languageId) {
				case 8:
					result = 'ja';
					break;
				case 9:
					result = 'zh-cn';
					break;
				case 10:
					result = 'zh-hk';
					break;
				default:
					break;
			}
		}
		return result;
	}

	static getUniqueParentName(params) {
		let parentName;

		Object.values(params).forEach((param) => {
			if (!parentName) {
				parentName = '';
			}
			if (!_.isEmpty(param)) {
				if (parentName !== '') {
					parentName += '_';
				}

				parentName += param;
			}
		});

		return parentName;
	}

	static validateDocumentName(documentName) {
		let error = false;
		let errorMessage = '';

		const regexEmpty = /^\s*$/;
		const regexCharacter = /^[^'"<*/:\\?|>']+$/i;

		if (regexEmpty.test(documentName)) {
			if (errorMessage !== '') {
				errorMessage += ' ';
			}

			errorMessage += labels.fileNameRequired;
		} else if (!documentName.match(regexCharacter)) {
			if (errorMessage !== '') {
				errorMessage += ' ';
			}

			errorMessage += labels.invalidCharacters;
		}

		if (documentName.length > documentNameMaxLength) {
			if (errorMessage !== '') {
				errorMessage += ' ';
			}

			errorMessage += labels.maxLengthExceeded;
		}

		if (errorMessage !== '') {
			error = true;
		} else {
			errorMessage = undefined;
		}

		return [error, errorMessage];
	}

	static findAttributeExistInQuerystring(props, attributeName) {
		const search = props.location && props.location.search ? props.location.search : window.location.search;
		let parsed = queryString.parse(search.toLowerCase());
		let attributeValue = attributeName && parsed[attributeName.toLowerCase()];
		let attributeFind = !!attributeValue;

		return {
			queryString: parsed,
			attributeFind: attributeFind,
			attributeValue: attributeValue
		};
	}

	static getReviewNotesModalData(noteType, store, ownProps) {
		if (_.isEmpty(store) || _.isEmpty(ownProps)) {
			return;
		}
		switch (noteType) {
			case reviewNotesType.document: {
				let documentIds = store.documentList[ownProps.parentName]?.documents?.allIds;

				if (documentIds) {
					return documentIds.map((documentId) => {
						const document = store.documentList[ownProps.parentName].response.data[documentId];

						return {
							value: document.id,
							label: document.documentName,
							extension: document.fileExt,
							documentTypeId: document.documentTypeId,
							hasComments: document.hasComments,
							hasHiddenSheets: document.hasHiddenSheets,
							hasHighlights: document.hasHighlights,
							isConflicted: document.isConflicted,
							trackChange: document.trackChange,
							isReturned: document.isReturned,
							isReadOnly: document.isReadOnly,
							isShared: document.isShared,
							engagementReviewNoteCount: document.engagementReviewNoteCount,
							engagementId: document.engagementId
						};
					});
				}
			}

			case reviewNotesType.task: {
				return store.taskDetails;
			}

			default:
				break;
		}
	}

	static parseQueryString(location, options = undefined) {
		const search = location && location.search ? location.search : window.location.search;

		return queryString.parse(search, options);
	}

	static hasValue(value) {
		let result = false;

		switch (typeof value) {
			case 'object':
				if (Array.isArray(value)) {
					if (value.length > 0) {
						result = true;
					}
				} else {
					result = !_.isEmpty(value);
				}
				break;
			case 'string':
				if (value !== undefined && value !== null && value.trim() !== '') {
					result = true;
				}
				break;
			default:
				if (value !== undefined && value !== null) {
					result = true;
				}
				break;
		}

		return result;
	}

	static getCurrentUrl(history) {
		let result = history?.location?.pathname || history?.pathname;

		if (result.startsWith('/')) {
			result = result.substring(1);
		}
		result = result.replaceAll('/', '_');

		return `${result}${encodeURIComponent(history?.location?.search || history?.search)}`;
	}

	static getDocumentName(fileName, ext) {
		if (ext && fileName.includes('.')) {
			return fileName
				.split('.')
				.slice(0, -1)
				.join('.');
		} else {
			return fileName;
		}
	}

	static getSortedData(inputData, columnsMapping, outputAttributesName) {
		let data = _.cloneDeep(inputData);
		if (Array.isArray(data)) {
			let groupedData = this.getGroupedData(data, columnsMapping, outputAttributesName);
			let flatData = [];
			_.map(groupedData, (value) => {
				let childs = value[outputAttributesName.groupChildrenListName];
				_.map(childs, (child) => {
					let item = {};
					item[columnsMapping.childItemId] = child[outputAttributesName.childId];
					item[columnsMapping.childItemName] = child[outputAttributesName.childName];
					item[columnsMapping.iconInformation] = child[outputAttributesName.iconName];
					item[columnsMapping.groupName] = value[outputAttributesName.parentGroupName];
					item[columnsMapping.groupId] = value[outputAttributesName.parentGroupId];
					flatData.push(item);
				});
			});

			return flatData;
		}

		return data;
	}

	static getAttributeName(outputAttributesNames, attributeName, name) {
		if (outputAttributesNames && outputAttributesNames[attributeName]) {
			return outputAttributesNames[attributeName];
		}

		return name;
	}

	static getFilteredData(groupedData, searchAttributes) {
		if (searchAttributes.searchText === '') {
			return groupedData;
		}
		let filterdData = _.cloneDeep(groupedData);
		filterdData = _.filter(filterdData, (value) => {
			if (value[searchAttributes.groupName].toLowerCase().includes(searchAttributes.searchText.toLowerCase())) {
				return true;
			}

			let childs = _.filter(value[searchAttributes.groupChildrenListName], (item) => {
				if (item[searchAttributes.childName].toLowerCase().includes(searchAttributes.searchText.toLowerCase())) {
					return true;
				}
				return false;
			});

			value[searchAttributes.groupChildrenListName] = childs;

			if (childs.length > 0) {
				return true;
			}

			return false;
		});

		return filterdData;
	}

	static sortGroupedData = (groupedData, groupName, childListName, childName) => {
		groupedData.sort(function(a, b) {
			return a[groupName].localeCompare(b[groupName]);
		});

		groupedData.map((value) => {
			value[childListName] = value[childListName].sort(function(a, b) {
				return a[childName].localeCompare(b[childName]);
			});

			return value;
		});

		return groupedData;
	};

	static sortListData = (data, attributeName, orderBy) => {
		let listData = _.cloneDeep(data);
		if (listData && !_.isEmpty(listData)) {
			if (
				listData.length > 0 &&
				!_.isUndefined(listData[0][attributeName]) &&
				typeof listData[0][attributeName] == 'string'
			) {
				listData.sort(function(a, b) {
					// below sorting does not work for value other the string
					if (a[attributeName] && b[attributeName]) {
						return a[attributeName].localeCompare(b[attributeName]);
					}
					return 0;
				});
			} else {
				// use orderBy to sort values other then string because orderBy does not sort special character if we use for strings
				listData = _.orderBy(listData, attributeName, orderBy);
			}
		}

		return listData;
	};

	static sortListDataForGivenOrder = (data, attributeName, orderBy) => {
		orderBy = orderBy ? orderBy : 'asc';
		if (data && !_.isEmpty(data)) {
			if (typeof data[0][attributeName] == 'string') {
				data.sort(function(a, b) {
					let value1, value2;
					value1 = !a[attributeName] ? '' : a[attributeName];
					value2 = !b[attributeName] ? '' : b[attributeName];
					return orderBy === 'asc' ? value1.localeCompare(value2) : value2.localeCompare(value1);
				});
			} else {
				// use orderBy to sort values other then string because orderBy does not sort special character if we use for strings
				data = _.orderBy(data, attributeName, orderBy);
			}
		}
		return data;
	};

	// Below function sort the list for the given sorting order and the attributes.
	static sortListByAttribute = (data, sortingOrder, sortByAttribute) => {
		data.map((group) => {
			group.tasks.sort(function(a, b) {
				let value_a = '',
					value_b = '';
				if (sortByAttribute[0] === 'taskStatus') {
					const taskStatus_a = GetTaskStatus(a.statusId, a.isEPEQRSignOffComplete);
					value_a =
						taskStatus_a && taskStatus_a.id && taskStatus_a.id > 0
							? currentResource.TaskStatus[taskStatus_a.id - 1].label
							: '';

					const taskStatus_b = GetTaskStatus(b.statusId, b.isEPEQRSignOffComplete);
					value_b =
						taskStatus_b && taskStatus_b.id && taskStatus_b.id > 0
							? currentResource.TaskStatus[taskStatus_b.id - 1].label
							: '';
				} else {
					_.forEach(sortByAttribute, function(attribute) {
						if (_.has(a, attribute)) {
							value_a = `${value_a} ${a[attribute] === null ? '' : a[attribute]}`;
							value_b = `${value_b} ${b[attribute] === null ? '' : b[attribute]}`;
						}
					});
				}
				return sortingOrder === 'asc' ? value_a.localeCompare(value_b) : value_b.localeCompare(value_a);
			});
			return group;
		});
		return data;
	};

	static sortTaskGroupedData = (groupedData, groupName, childListName, childName, categoryId) => {
		let filteredTaskTypeId = [];
		switch (categoryId) {
			case TaskCategories.ExecutionAccounts: {
				filteredTaskTypeId.push(TaskTypeEnum.ACCOUNT_CONCLUSION_TASK);
				break;
			}
		}
		groupedData.sort(function(a, b) {
			return a[groupName].localeCompare(b[groupName]);
		});

		groupedData.map((value) => {
			let filteredItems = value[childListName].filter((item) => {
				return !filteredTaskTypeId.includes(item.typeId);
			});
			filteredItems = filteredItems.sort(function(a, b) {
				return a[childName].localeCompare(b[childName]);
			});

			let nonFilteredItems = value[childListName].filter((item) => {
				return filteredTaskTypeId.includes(item.typeId);
			});
			nonFilteredItems = nonFilteredItems.sort(function(a, b) {
				return a[childName].localeCompare(b[childName]);
			});

			if (filteredTaskTypeId.includes(TaskTypeEnum.ACCOUNT_CONCLUSION_TASK)) {
				value[childListName] = [...filteredItems, ...nonFilteredItems];
			} else {
				value[childListName] = [...nonFilteredItems, ...filteredItems];
			}

			return value;
		});

		return groupedData;
	};

	static getGroupedData(items, groupByAttributes, outputAttributesName) {
		let childListName = 'childs';
		let parentGroupId = 'groupId';
		let parentGroupName = 'groupName';
		let childId = 'id';
		let childName = 'name';
		let iconName = 'iconInformation';
		let entityCount = 'entityCount';
		if (outputAttributesName) {
			childListName = outputAttributesName.groupChildrenListName && outputAttributesName.groupChildrenListName;
			parentGroupId = outputAttributesName.parentGroupId && outputAttributesName.parentGroupId;
			parentGroupName = outputAttributesName.parentGroupName && outputAttributesName.parentGroupName;
			childId = outputAttributesName.childId && outputAttributesName.childId;
			childName = outputAttributesName.childName && outputAttributesName.childName;
			iconName = outputAttributesName.iconName && outputAttributesName.iconName;
			entityCount = outputAttributesName.entityCount && outputAttributesName.entityCount;
		}

		let groupByColumn = groupByAttributes.groupByAttributeName
			? groupByAttributes.groupByAttributeName
			: groupByAttributes;
		let groupedData = _.chain(items)
			.groupBy(groupByColumn)
			.map((value, key) => {
				let groupName = value[0][groupByAttributes.groupName];
				let groupId = value[0][groupByAttributes.groupId];

				value = value.filter((item) => {
					return item.engagementTagId > 0;
				});

				return {
					[parentGroupId]: Number(groupId), //the index was transformed into a string, this will make it a number again.
					[parentGroupName]: groupName,
					[childListName]: _.map(value, (item) => {
						return {
							[childId]: item[groupByAttributes.childItemId],
							[childName]: item[groupByAttributes.childItemName],
							[iconName]: item[groupByAttributes.iconInformation],
							[entityCount]: item[groupByAttributes.entityCount]
						};
					})
				};
			})
			.value();

		groupedData = this.sortGroupedData(groupedData, parentGroupName, childListName, childName);
		return groupedData;
	}

	static getItemsFromGroupedData(groupedData, childrenListName) {
		let rowItems = [];
		groupedData.map((group) => {
			rowItems = [...rowItems, ...group[childrenListName]];
		});

		return rowItems;
	}

	static getTaskAssignmentsURL(engagementId, taskId) {
		return (
			env.getBaseURL(serviceURL, engagementId) +
			taskApiRoutes.task +
			taskId +
			`/${assignmentApiRoutes.assignment}?AssignedTo=TaskAssignments`
		);
	}

	static getAssignmentQueryString(
		assignmentTypeId,
		includeCounts = false,
		includeList = false,
		searchString = '',
		assignmentId = null,
		assignedToRoleId = null,
		assignedToUserId = null,
		pageNumber = 1,
		pageSize = 20,
		FilterHasRelatedTasks = false
	) {
		let filter = `includeCounts=${includeCounts}&includeList=${includeList}&assignmentTypeId=${assignmentTypeId}&searchString=${searchString}&pageNumber=${pageNumber}&pageSize=${pageSize}&FilterHasRelatedTasks=${FilterHasRelatedTasks}`;

		if (assignmentId) {
			filter += `&assignmentId=${assignmentId}`;
		}

		if (assignedToRoleId) {
			filter += `&assignedToRoleId=${assignedToRoleId}`;
		}

		if (assignedToUserId) {
			filter += `&assignedToUserId=${assignedToUserId}`;
		}

		return filter;
	}

	static getAssignmentCircleProportion(assignment, taskStatusId) {
		if (assignment.isComplete) {
			return circleProportions.full;
		} else if (!assignment.isComplete && assignment.isCurrent && taskStatusId !== TaskStatusIds.Open) {
			return circleProportions.half;
		} else {
			return circleProportions.empty;
		}
	}

	static getJsonPatchDocumentElement(operation, property, propertyValue) {
		return {op: operation, path: property, value: propertyValue};
	}

	static getGroupAuditScopesURL(engagementId, taskId) {
		return `${env.getBaseURL(serviceURL, engagementId)}GroupTasks/${taskId}/GroupComponents?pendingEvidence=true`;
	}

	static getSDMFeatureRestricted({
		restrictedCountryIds,
		validServiceLines,
		countryId,
		engServiceLineId,
		engSubServiceLineId
	}) {
		// By default it is true so we don't trigger a render and then a hide
		if (!(countryId > 0)) {
			return true;
		}

		if (_.some(restrictedCountryIds, (id) => id === -1 || id === countryId)) {
			// if -1 value is available in list then disable at LDC level
			return true;
		}

		//If serviceline and subserviceline combination matched then it should not be restricted.
		let isUnrestrictedServiceLine = !_.some(
			validServiceLines,
			({serviceLineId, subServiceLineId}) =>
				serviceLineId === engServiceLineId && subServiceLineId === engSubServiceLineId
		);

		return isUnrestrictedServiceLine;
	}

	static skipTaskDetailNavigation(e, noOfParentsNodesScan, inputClassList) {
		let skipNavigation = false;
		let target = e.target;
		if (e && !e.target) {
			return false;
		}
		for (let counter = 0; counter < noOfParentsNodesScan; counter++) {
			if (target && target.className) {
				if (Array.isArray(target.className)) {
					target.className.some((className) => {
						skipNavigation = inputClassList.includes(className);
						if (skipNavigation) {
							return true;
						}
					});
					if (skipNavigation) {
						break;
					}
				} else {
					skipNavigation = inputClassList.includes(target.className);
					if (skipNavigation) {
						break;
					}
				}
			}
			target = target && target.parentNode;
		}

		return skipNavigation;
	}

	static getDocumentIsConfidential(document) {
		let isConfidential = false;
		if (document.confidentialityTypeId !== undefined) {
			isConfidential =
				document.confidentialityTypeId !== null && document.confidentialityTypeId !== confidentialityTypes.DEFAULT;
		}
		return isConfidential;
	}

	static getDocumentIsRestricted(engagementStatusId, engagementSourceId, fileExt) {
		return (
			engagementStatusId === EngagementStatus.CanvasExternalAccessPortalV2 &&
			engagementSourceId === EngagementSource.CanvasExternalAccessPortalV2 &&
			RestrictedDocumentFileExt.some((restricted) => restricted === fileExt.toLowerCase())
		);
	}

	static getDocumentIsOpenable(
		{engagementId, engagementStatusId, engagementSourceId},
		userConfidentialityTypeId,
		document,
		skipFidentialityCheck = false
	) {
		let isOpenable = false,
			message;

		if (this.isPaperProfile(document.documentTypeId)) {
			isOpenable = false;
		} else if (!this.getDocumentIsRestricted(engagementStatusId, engagementSourceId, document.fileExt)) {
			if (!this.isDocumentDisabledInV2(document.documentTypeId)) {
				if (!skipFidentialityCheck) {
					if (engagementId === document.engagementId) {
						if (
							this.isConfidentialByUserConfidentialtyType(document.confidentialityTypeId, userConfidentialityTypeId)
						) {
							isOpenable = true;
						} else {
							message = labels.confidentialityNotOpenable;
						}
					} else {
						if (!document.confidentialityTypeId) {
							isOpenable = true;
						} else {
							message = labels.confidentialityTargetNotOpenable;
						}
					}
				} else {
					return [true, message];
				}
			}
		}
		return [isOpenable, message];
	}

	static isConfidentialByUserConfidentialtyType(confidentialityTypeId, userConfidentialityTypeId) {
		return !confidentialityTypeId || userConfidentialityTypeId >= confidentialityTypeId;
	}

	/**
	 * Determines whether a document is confidential to the user or not.
	 * @param {Number} engagementId Current engagement id.
	 * @param {Number} userConfidentialityTypeId User confidentiality level on the current engagement.
	 * @param {Object} document Document object.
	 * @returns true if the document is confidential to the user (ie cannot open it); false otherwise.
	 */
	static isDocumentConfidentialForUser(engagementId, userConfidentialityTypeId, document) {
		/* For now, confidential documents are not accessible from the target engagement. */
		if (engagementId !== document.engagementId && !isNullOrUndefined(document.confidentialityTypeId)) {
			return true;
		} else if (!document.confidentialityTypeId || userConfidentialityTypeId >= document.confidentialityTypeId) {
			return false;
		}
		return true;
	}

	static getPriorPeriodTasks(statusId, data) {
		let priorPeriodTaskIds = [];
		data
			.filter((sr) => sr.statusId === statusId)
			.map((req) => {
				let taskIds = _.map(req.tasks, ({id}) => {
					return id;
				});

				priorPeriodTaskIds = [...priorPeriodTaskIds, ...taskIds];
			});

		return priorPeriodTaskIds;
	}

	static isUserDarkMode = (userPreferences) => {
		if (userPreferences && userPreferences.userPreferencesJson) {
			let userPreferencesJson = JSON.parse(userPreferences.userPreferencesJson);
			return userPreferencesJson.theme === userTheme.dark;
		}
	};

	static setMotifTheme = (themeName) => {
		document.getElementsByTagName('body')[0].setAttribute('motif-theme', themeName);
		document
			.getElementsByTagName('body')[0]
			.setAttribute('class', themeName === userTheme.light ? 'motif-theme-light' : 'motif-theme-dark');
	};

	static getActivityTypeRoute = (section, item) => {
		const selectedItem = activityTypeRoute.find((x) => x.section === section && x.item === item);

		if (selectedItem) {
			return selectedItem.route;
		}

		return '';
	};

	static isDocumentAlwaysRenamable = (documentTypeId) => {
		return AlwaysRenamableDocumentTypeIds.some((e) => e === documentTypeId);
	};
	static clientRequestsNoRowsMessages(quickFilter) {
		let message;
		switch (quickFilter) {
			case collaborationQuickFiltersTabsConstanst.all:
				message = labels.nowRowOverlayClientRequest.all;
				break;
			case collaborationQuickFiltersTabsConstanst.draft:
				message = labels.nowRowOverlayClientRequest.draft;
				break;
			case collaborationQuickFiltersTabsConstanst.pending:
				message = labels.nowRowOverlayClientRequest.pending;
				break;
			case collaborationQuickFiltersTabsConstanst.received:
				message = labels.nowRowOverlayClientRequest.received;
				break;
			case collaborationQuickFiltersTabsConstanst.accepted:
				message = labels.nowRowOverlayClientRequest.accepted;
				break;
			default:
				break;
		}

		return message;
	}

	static roundFileSize = (number) => {
		if (number < 1 && number > 0) {
			return 1;
		} else {
			return Math.round(number);
		}
	};

	static isDarkTheme = () => document.getElementsByTagName('body')[0].getAttribute('motif-theme') === 'dark';

	static isValidDocument = (documentName) => {
		let result = true;
		let docExt = documentName && documentName.split('.')[1];
		if (
			docExt &&
			(env.getDocHelperConfig().unallowedZipFileExtentions.indexOf(docExt) > 0 ||
				env.getDocHelperConfig().UploadAllowedFileExtensions.indexOf(docExt) < 0)
		) {
			result = false;
		}

		if (documentName && documentName.length > 120) {
			result = false;
		}

		return result;
	};

	static getColorTag = (tag) => {
		if (tag.colorCode) {
			return tag.colorCode.toLowerCase();
		} else {
			return tag.isClientCreated ? defaultClientTagColor.toLowerCase() : defaultEYTagColor.toLowerCase();
		}
	};

	static removeTags(str) {
		if (!str || str === null || str === '') return false;
		else str = str.toString();
		return str.replace(/(<([^>]+)>)/gi, '');
	}

	/**
	 * loads data from session storage for a given key.
	 * @param {string} key: key to get from session storage
	 * @returns {object} the object from session storage
	 */
	static loadStorage = (key) => {
		try {
			const serializedState = sessionStorage.getItem(key);

			if (serializedState === null) {
				return {};
			}

			return JSON.parse(serializedState);
		} catch (err) {
			return {};
		}
	};

	/**
	 * loads data from session storage for a given key.
	 * @param key
	 * @param state
	 */
	static saveStorage = (key, state) => {
		try {
			const serializedState = JSON.stringify(state);

			sessionStorage.setItem(key, serializedState);
		} catch (err) {
			return {};
		}
	};

	/**
	 * clears data from session storage for a given key.
	 * @param key
	 */
	static clearStorage = (key) => {
		try {
			sessionStorage.removeItem(key);
		} catch (err) {
			return {};
		}
	};

	/**
	 * forms requests path.
	 * @param {int} filterTypeId - filter type id (received,sent or accepted)
	 * @param {int} quickFilterId - quick filter id (my requests or all requests)
	 * @param {int} clientRequestId - selected client request id
	 * @param {int} engagementId - engagement id
	 * @param {int} currentPage - current page from pagination control
	 * @param {int} pageSize - page size from pagination control
	 * @param {string} hash - If present will open the corresponding modal (i.e Add Custom Request)
	 * @returns {string} request path to push it to the route
	 * */
	static buildRequestsPath(
		filterTypeId,
		quickFilterId = collaborationFilterTypeEnum.allrequests,
		clientRequestId,
		engagementId,
		currentPage,
		pageSize,
		hash = ''
	) {
		let requestsPath =
			'/collaboration/requests/' +
			filterTypeId +
			'/' +
			quickFilterId +
			'/' +
			(clientRequestId ? clientRequestId : '') +
			'?' +
			'engagementid=' +
			engagementId +
			'&pagenumber=' +
			(currentPage ? currentPage : defaultCurrentPage) +
			'&pagesize=' +
			(pageSize ? pageSize : defaultPageSize) +
			hash;

		return requestsPath;
	}

	static buildCalendarPath(filterTypeId, clientRequestId, engagementId) {
		let calendarPath =
			'/collaboration/calendar/' +
			filterTypeId +
			'/' +
			(clientRequestId ? clientRequestId : '') +
			'?' +
			'engagementid=' +
			engagementId;

		return calendarPath;
	}

	static buildAnalyticsPath(engagementId) {
		let analyticsPath = '/collaboration/analytics' + '?' + 'engagementid=' + engagementId;

		return analyticsPath;
	}

	static getCommentStatusIdFromAnnotation = (annotationId) => {
		switch (annotationId) {
			case reviewNoteStatus.Open.id:
				return engagementCommentStatus.Open.id;
			case reviewNoteStatus.Closed.id:
				return engagementCommentStatus.Closed.id;
			case reviewNoteStatus.Cleared.id:
				return engagementCommentStatus.Cleared.id;
			default:
				return 0;
		}
	};

	static getAnnotationIdFromComment = (commentId) => {
		switch (commentId) {
			case engagementCommentStatus.Open.id:
				return reviewNoteStatus.Open.id;
			case engagementCommentStatus.Closed.id:
				return reviewNoteStatus.Closed.id;
			case engagementCommentStatus.Cleared.id:
				return reviewNoteStatus.Cleared.id;
			default:
				return 0;
		}
	};

	static getNoteStatusID = (entityTypeID, annotationStatusID) => {
		return entityTypeID === entities.engagementComment
			? this.getCommentStatusIdFromAnnotation(annotationStatusID)
			: annotationStatusID;
	};

	static getEngagementCommentsApiUrl = (entityTypeID, engId, noteId = undefined) => {
		const endpoint =
			entityTypeID === entities.engagementComment
				? `${reviewNoteRoutes.engagementComment}${noteId ?? ''}`
				: reviewNoteRoutes.annotation;
		const url = env.getBaseURL(serviceURL, engId) + endpoint;
		return url;
	};

	static kendoEditorTrim = (value) => value.replace(/&nbsp;/g, ' ').trim();

	//On the api the validation is named: removeRitchText
	static removeRichText = (value) =>
		(value &&
			value
				.replace(/&nbsp;/g, ' ')
				.replace(/\uFEFF/g, '')
				.trim()
				.replaceAll(/<.*?>/g, '')
				.replaceAll(/[^\u0000-\uFFFF]+/g, '') // Allow double-byte characters
				.replaceAll('&amp;', '&')
				.replaceAll('&lt;', '<')
				.replaceAll('&gt;', '>')) ||
		'';

	static getInitials = (names) => {
		let _names = names || '';
		let initials = '';

		if (_names.split(' ').length === 1) {
			initials = names;
		} else {
			initials = _names
				.split(' ')
				.map((item) => item.charAt(0))
				.join('');
		}

		return initials?.substring(0, 3).toUpperCase();
	};

	static getGALinkStatusIcon = (gaLinkStatusId) => {
		let svgIcon = '';
		let colorFill = '';
		const theme = getTheme(this.isDarkTheme());
		const statusLabel = currentResource.gaLinkStatusObj[gaLinkStatusId] || '';

		switch (gaLinkStatusId) {
			case GALinkStatus.Accepted:
				colorFill = theme.color['green600'];
				svgIcon = actionIcCheckCircle24px;
				break;
			case GALinkStatus.Pending:
				colorFill = theme.color['grey600'];
				svgIcon = actionIcQueryBuilder24px;
				break;
			case GALinkStatus.Unlinked:
			case GALinkStatus.ComponentNotUsingCanvas:
				//TODO: replace when motif add the icon.
				colorFill = theme.color['black'];
				svgIcon =
					'<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="2 0 20 20" width="20px" x="190" y="10" fill="' +
					colorFill +
					'" class="status-icon"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M14.39 11L16 12.61V11zM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4C21.05 15.36 22 13.79 22 12c0-2.76-2.24-5-5-5zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z"/><title>' +
					statusLabel +
					'</title></svg>';
				break;
			case GALinkStatus.SystemError:
			case GALinkStatus.Rejected:
			case GALinkStatus.Expired:
			case GALinkStatus.InvalidPointOfContact:
				colorFill = theme.color['red600'];
				svgIcon = alertIcError24px;
				break;
		}

		if (svgIcon) {
			if (gaLinkStatusId !== GALinkStatus.Unlinked && gaLinkStatusId !== GALinkStatus.ComponentNotUsingCanvas) {
				svgIcon = decodeURI(svgIcon.substring(19));
				svgIcon = svgIcon
					.split('%3D')
					.join('=')
					.split('%2F')
					.join('/')
					.split('%3A')
					.join(':')
					.split('</svg>')
					.join('<title>' + statusLabel + '</title></svg>')
					.split('<svg')
					.join('<svg x="190" y="10" fill="' + colorFill + '" class="status-icon"')
					.split('width="24" height="24" viewBox="0 0 24 24"')
					.join('width="20" height="20" viewBox="0 0 24 24"');
			}

			svgIcon =
				'<circle cx="200" cy="22" r="10" fill="transparent"><title>' + statusLabel + '</title></circle>' + svgIcon;
		}

		return svgIcon;
	};

	static hasPOC(gaLinkStatusId) {
		switch (gaLinkStatusId) {
			case GALinkStatus.NoPointOfContact:
			case GALinkStatus.ComponentNotUsingCanvas:
			case GALinkStatus.ComponentReferenceOnly:
				return false;
			default:
				return true;
		}
	}

	static getImgHTML(userEmail, hasPhoto, pocText, gaLinkStatusId) {
		const theme = getTheme(this.isDarkTheme());
		if (
			gaLinkStatusId === GALinkStatus.ComponentNotUsingCanvas ||
			gaLinkStatusId === GALinkStatus.ComponentReferenceOnly ||
			gaLinkStatusId === GALinkStatus.NoPointOfContact
		) {
			let label = currentResource.gaLinkStatusObj[gaLinkStatusId];
			const title = currentResource.gaLinkStatusObj[gaLinkStatusId];
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');
			let text = ctx.measureText(label);
			if (text.width > 180) {
				const maxLenght = (180 * label.length) / text.width;
				label = label.substr(0, maxLenght) + '...';
			}

			const ellipsis = '<title>' + title + '</title>' + label;
			return (
				'<text width="140" text-overflow="ellipsis" style="font-size: var(--px-12);" x="15" y="75" text-anchor="left" fill=' +
				theme.color[`black`] +
				' >' +
				ellipsis +
				'</text>'
			);
		}

		if (hasPhoto) {
			return (
				'<clipPath id="{randId}"><circle cx="30" cy="80" r="15"></circle></clipPath><image preserveAspectRatio="xMidYMid slice" clip-path="url(#{randId})" xlink:href="' +
				hasPhoto +
				'" x="15" y="65"  width="30" height="30"></image>'
			);
		} else {
			let initials = this.getInitials(pocText);
			return (
				'<circle cx="30" cy="80" r="16" fill="' +
				theme.color['teal500'] +
				'"></circle><text style="font-size: var(--px-14);" x="30" y="84" text-anchor="middle" fill="' +
				theme.color['white'] +
				'">' +
				initials +
				'</text>'
			);
		}
	}

	static sortRowsData = (data, attributeName, orderByAscending, orderByColumnsList) => {
		let orderBy = orderByAscending ? 'asc' : 'desc';
		let orderColumns = [attributeName];
		if (orderByColumnsList) {
			orderColumns = orderByColumnsList;
		}
		if (data && !_.isEmpty(data)) {
			if (orderColumns.length > 1) {
				const firstCol = orderColumns[0];
				data = this.sortListDataForGivenOrder(data, firstCol, orderBy);
				let uniqueObjects = _.uniqBy(data, function(e) {
					return e[firstCol];
				});
				let groupedData = _.groupBy(data, firstCol);
				let sortedDataList = [];
				const secondColumn = orderColumns[1];
				uniqueObjects.map((obj) => {
					// because group by change the order for numeric character names that why we are fetching unique keys first to maintain order

					const key = obj[firstCol];
					if (groupedData[key].length > 1) {
						let sortedData = this.sortListDataForGivenOrder(groupedData[key], secondColumn, orderBy);
						sortedDataList = [...sortedDataList, ...sortedData];
					} else {
						sortedDataList = [...sortedDataList, ...groupedData[key]];
					}
				});
				data = sortedDataList;
			} else {
				const sortedData = this.sortListDataForGivenOrder(data, orderColumns[0], orderBy);
				data = sortedData;
			}
		}

		return data;
	};

	static mergeInconsistentFormValidation = (validationsToDisplay) => {
		const otherFormValidations = validationsToDisplay?.filter(
			(x) => x.validationTypeId !== validationTypes.IndependenceViewTemplateNotSubmitted
		);
		const inconsistentFormValidations = validationsToDisplay?.filter(
			(x) => x.validationTypeId === validationTypes.IndependenceViewTemplateNotSubmitted
		);
		let validations = [...otherFormValidations];
		if (inconsistentFormValidations.length > 0) {
			const resultValidation = {
				children: [],
				documentId: uuidv4.NIL,
				documentName: '',
				documentTypeId: documentTypes.INDEPENDENCEFORMINDIVIDUAL,
				id: uuidv4.NIL,
				uniqueId: null,
				validationCount: inconsistentFormValidations.length,
				validationEntityId: 0,
				validationGroupId: ValidationGroup.IndependenceValidations,
				validationId: null,
				validationName: null,
				validationSubGroupId: validationTypes.IndependenceViewTemplateNotSubmitted,
				validationTypeId: validationTypes.IndependenceViewTemplateNotSubmitted
			};

			validations = [...validations, resultValidation];
		}
		return validations;
	};

	static getTheme() {
		return document.getElementsByTagName('body')[0].getAttribute('motif-theme') === 'light' ? null : 'dark';
	}

	/* Notes modal utility functions */
	static getLocalDate = (date, userPreferences) => {
		return Moment.utc(date)
			.local()
			.locale(Utility.getLocale(userPreferences));
	};
	/* Notes modal utility functions */

	/*utility function for advance search feature */
	static isSearchTermValid = (searchTerm) => {
		return !isNullOrWhitespace(searchTerm) ? searchTerm : null;
	};

	static buildSearchColumnsParams = (selectedAdvancedSearchOptions) => {
		return selectedAdvancedSearchOptions
			?.filter((option) => {
				return option.isChecked;
			})
			?.map((x) => {
				return x.id;
			})
			?.join(',');
	};

	static buildQueryStringArray = (paramName, paramArray) => {
		paramArray = paramArray?.map(encodeURIComponent);
		return paramName + '=' + paramArray.join('&' + paramName + '=');
	};
	/*utility function for advance search feature */

	/* Utility function to ensure that percentage sum is 100. */
	static adjustPercentages = (items) => {
		let totalPercentage = _.sum(items.map((data) => data.percentage));
		let item = _.maxBy(items, 'percentage');
		if (isNaN(totalPercentage)) {
			return items;
		}
		item.percentage = item.percentage + (100 - totalPercentage);
		return items;
	};

	static getDecodedText = (noteText) => {
		try {
			return decodeURIComponent(noteText);
		} catch {
			return noteText;
		}
	};

	static addDays = (date, days) => {
		let returnDate = new Date(date);
		returnDate.setDate(returnDate.getDate() + days);
		return returnDate;
	};

	/**
	 * Returns A value indicating whether the task is Ep or not.
	 * @param {boolean} isEPSignoffRequired
	 * @param {boolean} isEPSignoffUserRequired
	 * @returns A value indicating whether the task is Ep or not.
	 */
	static taskIsEp(isEPSignoffRequired, isEPSignoffUserRequired) {
		return isEPSignoffRequired || isEPSignoffUserRequired;
	}

	/**
	 * Returns A value indicating whether the task is Eq or not.
	 * @param {boolean} isEQRSignoffRequired
	 * @param {boolean} isEQRSignoffUserRequired
	 * @returns A value indicating whether the task is Eq or not.
	 */
	static taskIsEq(isEQRSignoffRequired, isEQRSignoffUserRequired) {
		return isEQRSignoffRequired || isEQRSignoffUserRequired;
	}

	/**
	 * Returns A value indicating whether the task is EpEqr or not.
	 * @param {boolean} taskIsEp
	 * @param {boolean} taskIsEq
	 * @returns A value indicating whether the task is EpEqr or not.
	 */
	static taskIsEpEqr(taskIsEp, taskIsEq) {
		return taskIsEp && taskIsEq;
	}

	/**
	 * Given a count, and three labels, returns the replaced string with the count value.
	 * @param {number} count The counter's actual count.
	 * @param {String} noResultsLabel A label to be shown when count equals zero
	 * @param {String} resultLabel A label to be shown when count equals one
	 * @param {String} resultsLabel A label to be shown when count is greater than 1
	 * @returns {String} A string with the '{0}' replaced by the count value.
	 */
	static getCounterLabel(count, noResultsLabel, resultLabel, resultsLabel) {
		if (count === 0) {
			return noResultsLabel;
		} else {
			return (count > 1 ? resultsLabel : resultLabel).replaceAll('{0}', count);
		}
	}

	/**
	 * Given a list of sign-offs, determines whether the current user a sign-off for this user exists or not.
	 * @param {Array} signoffs Sign-offs list.
	 * @param {String} loggedInUserId Logged in user id.
	 * @returns true if a sign-off made by the current user exists; otherwise, false.
	 */
	static currentUserSignOffExists(signoffs, loggedInUserId) {
		return signoffs && this.findSignOffByFilter(signoffs, (s) => s.approvalUserId === loggedInUserId);
	}

	/**
	 * Given a list of sign-offs, determines whether a sign-off made by a user with the Partner in Charge role exists.
	 * @param {Array} signoffs Sign-offs list.
	 * @returns true if a sign-off made by a Partner in charge current user exists; otherwise, false.
	 */
	static PiCSignOffExists(signoffs) {
		return signoffs && this.findSignOffByFilter(signoffs, (s) => s.hasOverallResponsibility);
	}

	/**
	 * Given a list of sign-offs, determines whether a sign-off made by a user with the EQR role exists.
	 * @param {Array} signoffs Sign-offs list.
	 * @returns true if a sign-off made by a EQR current user exists; otherwise, false.
	 */
	static EQRSignOffExists(signoffs) {
		return this.findSignOffByFilter(signoffs, (s) => s.engagementRoleId === EngagementRoles.AuditQualityReviewer);
	}

	static findSignOffByFilter(signoffs, filter) {
		return signoffs && filter && signoffs.findIndex((s) => filter(s)) !== -1;
	}

	static getInstructionStatusId(instructionStatusId, linkStatusId) {
		if (linkStatusId === GALinkStatus.ComponentNotUsingCanvas || linkStatusId === GALinkStatus.ComponentReferenceOnly)
			return 0;

		if (!instructionStatusId) return 1;

		return instructionStatusId;
	}

	static isCalendar(_location, _filterTypeId) {
		const pathnameRoute = _location.pathname.split('/');
		return pathnameRoute[2] === collaborationFilterTypeEnum.calendar;
	}
	static isAnalytics(_location, _filterTypeId) {
		const pathnameRoute = _location.pathname.split('/');
		return pathnameRoute[2] === collaborationFilterTypeEnum.analytics;
	}

	static isMyRequests(_location) {
		const pathnameRoute = _location.pathname.split('/');
		return pathnameRoute[3] === collaborationFilterTypeEnum.myrequests;
	}

	static buildRequiredPath(
		activeTabId,
		isAssignedToMeChecked,
		requestId,
		engagementId,
		quickfilterId,
		currentUrlParams
	) {
		let url;
		const filterTypeIdUrl = isAssignedToMeChecked
			? collaborationFilterTypeEnum.myrequests
			: collaborationFilterTypeEnum.allrequests;
		switch (activeTabId) {
			case collaborationFilterTypeEnum.calendar:
				url = this.buildCalendarPath(filterTypeIdUrl, !_.isEmpty(requestId) ? requestId : '', engagementId);
				break;
			case collaborationFilterTypeEnum.analytics:
				url = this.buildAnalyticsPath(engagementId);
				break;
			default:
				if (currentUrlParams.get('pagesize')) {
					url = this.buildRequestsPath(
						filterTypeIdUrl,
						quickfilterId,
						requestId,
						engagementId,
						1,
						currentUrlParams.get('pagesize')
					);
				} else {
					url = this.buildRequestsPath(filterTypeIdUrl, quickfilterId, requestId, engagementId, null, null);
				}
				break;
		}

		return url;
	}

	static getPICEQRDocumentListFilters(engagementRequiresEQR) {
		let options = filters.signoffRequirements;
		let _filters = currentResource.filterSignoffRequirements?.filter(
			(f) => f.value === options.picMandatory || f.value === options.picTeamAssigned
		);

		if (engagementRequiresEQR) {
			let _eqrFilters = currentResource.filterSignoffRequirements?.filter(
				(f) => f.value === options.eqrMandatory || f.value === options.eqrTeamAssigned
			);
			_filters = _filters.concat(_eqrFilters);
		}

		return _filters;
	}
	static getMissingRelatedTaskFilters(engagementRequiresEQR) {
		let options = filters.missingRelatedTask;
		let _filters = currentResource.filterMissingRelatedTask?.filter((f) => f.value === options.picSignoffRequired);

		if (engagementRequiresEQR) {
			let _eqrFilters = currentResource.filterMissingRelatedTask?.filter((f) => f.value === options.eqrSignoffRequired);
			_filters = _filters.concat(_eqrFilters);
		}

		return _filters;
	}

	static getAllUnassignedTasks(engagementId, userId, taskType) {
		let url =
			env.getBaseURL(serviceURL, engagementId) +
			'Tasks' +
			'?categoryId=' +
			OfflineTaskListFilters.categoryId +
			'&subcategoryId=' +
			OfflineTaskListFilters.subcategoryId +
			'&pageSize=' +
			5000 +
			'&currentPage=' +
			1 +
			'&includeCounts=' +
			true +
			'&includeTaskList=' +
			true +
			'&tasktype=' +
			taskType;

		if (userId?.length > 0) {
			for (let i = 0; i < userId.length; i++) url += '&filterNotAssignedToUser=' + userId[i];
		}

		return url;
	}

	static getCustomExportHeaders(headerObj) {
		let customHeaderArray = [];
		Object.keys(headerObj).forEach((key) => {
			let customObj = {
				type: 'header',
				cells: [
					{
						value: key,
						colSpan: 1,
						firstCell: true,
						textAlign: 'left',
						rowSpan: 1,
						format: '@'
					},
					{
						value: headerObj[key],
						colSpan: 1,
						firstCell: false,
						textAlign: 'left',
						rowSpan: 1,
						format: '@'
					}
				]
			};
			customHeaderArray.push(customObj);
		});
		return customHeaderArray;
	}

	static isReviewEngagement(engagement) {
		return (
			ReviewTypeSourceIds.indexOf(engagement.engagementSourceId) > -1 ||
			engagement.engagementStatusId === EngagementStatus.CanvasExternalAccessPortalV2
		);
	}

	static commonSignOfRequirementsCompleted(engagement) {
		if (!engagement) {
			return true;
		}

		return (
			moment.utc(engagement.clientYearEndDate) >= moment.utc(signOffRequirementsClientYearDate) &&
			!this.isReviewEngagement(engagement)
		);
	}

	static requiresPIC(document, tasks) {
		return (
			(document.isEPSignoffRequired || document.isEPSignoffUserRequired) &&
			!tasks.find((t) => t.isEPSignoffRequired || t.isEPSignoffUserRequired)
		);
	}

	static requiresEQR(document, tasks, isEngagementEQRSignoffRequired) {
		return (
			isEngagementEQRSignoffRequired &&
			(document.isEQRSignoffRequired || document.isEQRSignoffUserRequired) &&
			!tasks.find((t) => t.isEQRSignoffRequired || t.isEQRSignoffUserRequired)
		);
	}

	static documentRequiresPICTask(document, tasks, additionalParams) {
		return this.commonSignOfRequirementsCompleted(additionalParams.engagement) && this.requiresPIC(document, tasks);
	}

	static documentRequiresEQRTask(document, tasks, additionalParams, isEngagementEQRSignoffRequired) {
		return (
			this.commonSignOfRequirementsCompleted(additionalParams.engagement) &&
			this.requiresEQR(document, tasks, isEngagementEQRSignoffRequired)
		);
	}

	static getTaskListGroupingLabel(value, engagementRequiresEQR) {
		switch (true) {
			case value === 'true' && engagementRequiresEQR:
				return labels.documentsWherePICEQRSignOffIsRequired;
			case value === 'true' && !engagementRequiresEQR:
				return labels.documentsWherePICSignOffIsRequired;
			case value !== 'true':
				return labels.otherDocuments;
		}
	}

	static engagementISA220Validations = (engagement) => {
		const isa220validationsDate = new Date(EngagementClientYearEndDate);
		const clientYearEndDate = new Date(engagement?.clientYearEndDate);
		return clientYearEndDate.getTime() >= isa220validationsDate.getTime();
	};

	static getNewUrl(urlString) {
		return new URL(urlString);
	}

	static isSuperModalSupportedMilestoneTask(taskBuildMilestoneId) {
		if (taskBuildMilestoneId && buildStepTaskMilestoneIds.includes(taskBuildMilestoneId)) {
			return true;
		}
		return false;
	}

	static isVoiceNoteRecordingEnabled = (state) => {
		// This value is from server configuration. It would applies for all engagements on that server.
		const serverIsVoiceNoteRecordingEnabled = !!state.configurations?.features?.isVoiceNoteRecordingEnabled;

		// This value only applies when one of the following occurs:
		// - US GAAS + Listed
		// - Canadian GAAS + Listed
		// - Canadian GAAS + Other public interest entity that is not listed
		const engagementIsVoiceNoteRecordingEnabled = !!state.engagement?.isVoiceNoteRecordingEnabled;

		return serverIsVoiceNoteRecordingEnabled && engagementIsVoiceNoteRecordingEnabled;
	};

	static formatSeconds = (sec) => {
		const minutes = Math.floor((sec % 3600) / 60);
		const seconds = Math.round(sec % 60);
		return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
	};
	static getNotePreviewForDashboard = (note) => {
		const {text = null, recordingId = null, annotationAttribute = null} = note;
		if (text && text !== '') return this.getDecodedText(text);
		if (annotationAttribute && recordingId !== emptyGuid) {
			let label = '',
				duration = '00:00';
			const parsed = JSON.parse(annotationAttribute);
			if (
				parsed.RecordingType === documentTypes.VOICE_RECORDING ||
				parsed.RecordingType === documentTypes.SCREEN_RECORD
			) {
				label = labels.recording;
			}
			duration = this.formatSeconds(parsed.RecordingLength);
			return `${label} ${duration}`;
		}

		return '';
	};

	static getNotePreview = (note) => {
		const {text = null, recordingId = null, annotationAttribute = null} = note;

		if (text && text !== '') return this.getDecodedText(text);

		if (annotationAttribute && recordingId !== emptyGuid) {
			let label = '',
				duration = '00:00';

			const parsed = JSON.parse(annotationAttribute);

			if (parsed.RecordingType === documentTypes.VOICE_RECORDING) label = labels.voiceNote;
			if (parsed.RecordingType === documentTypes.SCREEN_RECORD) label = labels.screenRecord;

			duration = this.formatSeconds(parsed.RecordingLength);

			return `${label} ${duration}`;
		}

		return '';
	};

	static validGuid = (guid) => {
		if (guid) {
			const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
			return guid.match(regex);
		}
		return false;
	};

	static isDocumentTypeFitV2 = (documentTypeId) => {
		return GuidedWorkflowV2DocumentTypes.includes(documentTypeId, 0);
	};

	static isDocumentCanvasForm = (documentTypeId) => {
		return CanvasFormsIds.includes(documentTypeId, 0);
	};

	/**
	 * Determines if the current page is in an iframe element.
	 * @returns {boolean} true if the current page is in an iframe element, false otherwise.
	 */
	static pageInIframe() {
		return window.location !== window.parent.location;
	}

	static quickAccessDocumentLink = (engagementId, accountId, entities) => {
		if (entities.length > 0) {
			return env.getKronosUrl(
				`guidedworkflowv2?engagementId=${engagementId}&taskcategoryid=account&filteredtaskcategoryuids=${accountId}&stentityid=${_.join(
					entities,
					'&stentityid='
				)}`
			);
		} else {
			return env.getKronosUrl(
				`guidedworkflowv2?engagementId=${engagementId}&taskcategoryid=account&filteredtaskcategoryuids=${accountId}`
			);
		}
	};

	static leadSheetUrl = (engagementId, accountId, entitySelected) => {
		const entityQuery = entitySelected?.length ? `&entities=${entitySelected}` : '';
		return `/leadsheet/${accountId}?engagementid=${engagementId}${entityQuery}`;
	};

	static convertUserPreferencesDateFormatToMoment(userFormat) {
		switch (userFormat) {
			case dateFormats[0].id:
				return 'MM/DD/YYYY';
			case dateFormats[1].id:
				return 'DD/MM/YYYY';
			case dateFormats[2].id:
				return 'YYYY/MM/DD';
		}
	}

	static parseGuidFromString(string) {
		// Define a regular expression that matches the GUID format
		const guidRegex = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;

		// Use the match method on string with the regular expression as the argument
		const matches = string.match(guidRegex);

		// If there are matches, the first element in the array will be the first GUID found in string
		const guid = matches ? matches[0] : null;

		// Now guid contains the first GUID found in string, or null if no GUID was found
		return guid;
	}

	static parseNumericValue(value) {
		return value ? parseInt(value) : 0;
	}

	static getControlCount(scot, wcgwId) {
		if (scot?.controls?.length > 0) {
			return scot.controls.filter((control) => control.wcgwId === wcgwId).length;
		} else return 0;
	}

	static showZeroCountInRedColorClassScot(scot) {
		return scot?.strategyTypeId === StrategyTypeIds.Controls ? 'no-count-red' : '';
	}

	static sortDefault(arr = [], sortKey) {
		return arr.slice().sort((a, b) => {
			const valueA = sortKey(a);
			const valueB = sortKey(b);
			return valueA.localeCompare(valueB, undefined, {numeric: true, sensivity: 'base'});
		});
	}

	static getLanguageIdForFederatedModule(language) {
		let languageId = 1;
		switch (language) {
			case 'en-us':
				languageId = 1;
				break;
			case 'fr-ca':
				languageId = 4;
				break;
			case 'es-mx':
				languageId = 5;
				break;
			case 'pt-br':
				languageId = 7;
				break;
			case 'ja-jp':
				languageId = 8;
				break;
			case 'zh-sp':
				languageId = 9;
				break;
			case 'zh-tr':
				languageId = 10;
				break;
			case 'he':
				languageId = 11;
				break;
			case 'ko':
				languageId = 12;
				break;
			case 'ru':
				languageId = 13;
				break;
			case 'ar-ms':
				languageId = 14;
				break;
			default:
				languageId = 1;
				break;
		}

		return languageId;
	}

	static getDateFormatIdForFederatedModule(dateFormat) {
		let dateFormatId = dateFormats.find((x) => x.format === dateFormat)?.id || 1;

		return dateFormatId;
	}

	/**
	 * This function sanitizes a given filename by replacing any invalid characters with an underscore and truncating the filename if it exceeds the maximum allowed length.
	 *
	 * @static
	 * @param {string} fileName - The filename to be sanitized.
	 * @returns {string} The sanitized filename.
	 */
	static getSanitizedAnalyticFilename(fileName) {
		/**
		 * This function replaces any invalid characters in a given bookmark name with an underscore and truncates the bookmark name if it exceeds the maximum allowed length.
		 *
		 * @param {string} bookMarkName - The bookmark name to be sanitized.
		 * @returns {string} The sanitized bookmark name.
		 */
		function getDocumentName(bookMarkName) {
			const invalidFileNameCharacters = '*/:<>\\?|';
			let documentName = bookMarkName
				.split('')
				.map((char) => (invalidFileNameCharacters.includes(char) ? '_' : char))
				.join('');
			const maxAllowedFileNameLength = 115;
			return truncateLongString(documentName, maxAllowedFileNameLength);
		}

		/**
		 * This function truncates a given string if it exceeds a given maximum length.
		 *
		 * @param {string} str - The string to be truncated.
		 * @param {number} maxLength - The maximum allowed length of the string.
		 * @returns {string} The truncated string.
		 */
		function truncateLongString(str, maxLength) {
			if (str.length <= maxLength) {
				return str;
			}
			return str.slice(0, maxLength);
		}

		let sanitizedFileName = getDocumentName(fileName);
		return sanitizedFileName;
	}
	static formatDate(value, userPreferences) {
		if (value) {
			const dateFormat = userPreferences.dateFormat ? userPreferences.dateFormat : defaultDateFormat;
			const userFormattedDate = moment(value).format(Utility.convertUserPreferencesDateFormatToMoment(dateFormat));
			return userFormattedDate;
		} else {
			return '-';
		}
	}

	static isDaaSDocumentCheckOutComplete(document) {
		return (
			document?.contentContractId === ContentContract.DaaS &&
			document?.documentStatusId === DocumentStatus.DaaSCheckoutComplete
		);
	}

	static isDaasDocumentCheckOutInProgress(document) {
		return document?.documentStatusId === DocumentStatus.DaaSCheckoutInProgress;
	}

	static isDaasDocumentCheckInCheckOutInProgress(document) {
		return this.isDaasDocumentCheckOutInProgress(document) || this.isDaaSDocumentCheckInInProgress(document);
	}

	static isDaaSDocumentCheckInInProgress(document) {
		return (
			document?.contentContractId === ContentContract.DaaS &&
			document?.documentStatusId === DocumentStatus.DaaSCheckinInProgress
		);
	}

	static isDaaSDocumentCheckInError(document) {
		return (
			document?.contentContractId === ContentContract.DaaS &&
			document?.documentStatusId === DocumentStatus.DaaSCheckinError
		);
	}

	static isDaaSDocumentDiscardInProgress(document) {
		return (
			document?.contentContractId === ContentContract.DaaS &&
			document?.documentStatusId === DocumentStatus.DaaSDiscardInProgress
		);
	}

	static isDaaSDocumentDiscardError(document) {
		return (
			document?.contentContractId === ContentContract.DaaS &&
			document?.documentStatusId === DocumentStatus.DaaSDiscardError
		);
	}

	static getTaskDetailsURL(engagement, taskId) {
		let requestUrl = '';
		if (engagement.isMultiEntityEngagement) {
			requestUrl =
				env.getBaseURL(serviceURL, engagement.engagementId) + 'Tasks/' + taskId + '/?includerelatedentities=true';
		} else {
			requestUrl = env.getBaseURL(serviceURL, engagement.engagementId) + 'Tasks/' + taskId;
		}
		return requestUrl;
	}

	static clientRequestDueDateIndicator(dueDate, clientRequestStatusId) {
		const validStatus = [...ParentPendingResponse];
		const isValidStatus = validStatus.includes(clientRequestStatusId);
		const days = moment(dueDate).diff(moment(), 'days', true);
		const isSameDay = moment(dueDate).isSame(moment(), 'day');
		if (isValidStatus && days < 0 && !isSameDay) {
			return {
				className: 'overdue',
				isOverdue: true
			};
		}

		const comingDueDays = Utility.getComingDueDaysCollaborations();
		if (isValidStatus && ((days <= comingDueDays && days > 0) || isSameDay)) {
			return {
				className: 'comingdue',
				isOverdue: false
			};
		}

		return {
			className: 'nodate-criteria',
			isOverdue: false
		};
	}

	/**
	 * Return the current date format based in user preferences.
	 * @param {object} userPreferences - userPreferences from store
	 * @param {bool} isLocale - isLocale. Defaults to false.
	 * @returns {string} current date format.
	 * */
	static getUserPreferencesDateValue(userPreferences, isLocale = false) {
		let dateFormat = isLocale
			? dateFormats[defaultDateFormat] && dateFormats[defaultDateFormat].value
			: dateFormats[defaultDateFormat] && dateFormats[defaultDateFormat].label;
		if (userPreferences?.isPreferencesLoaded) {
			dateFormat =
				dateFormats[userPreferences?.dateFormat] &&
				(isLocale ? dateFormats[userPreferences?.dateFormat].value : dateFormats[userPreferences?.dateFormat].label);
		}
		return dateFormat;
	}

	static getFormattedDate = (date, dateFormat) => {
		if (date instanceof moment) {
			return date.format(dateFormat);
		}
		return date;
	};

	static getFormattedDateValue(userPreferences, date) {
		if (userPreferences && date) {
			let userDateFormat = this.getUserPreferencesDateValue(userPreferences);
			const formatedDate = moment(date);
			return this.getFormattedDate(formatedDate, userDateFormat);
		}

		return '';
	}

	static isDocumentEligibleForDaaSCheckedOut(documentStatusId, contentContractId) {
		return (
			contentContractId === ContentContract.DaaS &&
			[
				DocumentStatus.DaaSCheckoutInProgress,
				DocumentStatus.DaaSCheckoutComplete,
				DocumentStatus.DaaSCheckinInProgress,
				DocumentStatus.DaaSDiscardInProgress,
				DocumentStatus.DaaSCheckinError,
				DocumentStatus.DaaSDiscardError
			].includes(documentStatusId)
		);
	}

	static isDocumentEligibleForDaaSCheckedIn(documentStatusId, contentContractId) {
		return (
			contentContractId === ContentContract.DaaS &&
			[DocumentStatus.DaaSCheckoutComplete, DocumentStatus.DaaSCheckinError, DocumentStatus.DaaSDiscardError].includes(
				documentStatusId
			)
		);
	}

	static convertDateToString(date) {
		return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(
			2,
			'0'
		)}T00:00:00.000`;
	}

	static getEvidenceDocumentTypeBasedOnTemporary = (document) => {
		const documentTypeMap = {
			[documentTypes.ITEVALUATIONTEMPORARYSMARTFORM]: documentTypes.ITEVALUATIONSMARTFORM,
			[documentTypes.CANVASFORMTEMPORARY]: documentTypes.CANVASFORMEVIDENCE,
			[documentTypes.PAPERPROFILETEMPORARY]: documentTypes.PAPERPROFILE,
			[documentTypes.GUIDEDWORKFLOWTEMPORARY]: documentTypes.GUIDEDWORKFLOW,
			[documentTypes.SMARTAUTOMATIONEVIDENCETEMPORARY]: documentTypes.SMARTAUTOMATIONEVIDENCE,
			[documentTypes.ACCOUNT_STANDARD_WORKING_PAPER_TEMPORARY]: documentTypes.ACCOUNT_STANDARD_WORKING_PAPER,
			[documentTypes.ALRA_INDIVIDUAL_TEMPORARY]: documentTypes.ALRA_INDIVIDUAL,
			[documentTypes.GUIDEDWORKFLOWV2_TEMPORARY]: documentTypes.GUIDEDWORKFLOWV2,
			[documentTypes.CONTROL_UNDERSTAND_CONTROLS_TEMPORARY]: documentTypes.CONTROL_UNDERSTAND_CONTROLS,
			[documentTypes.CONTROL_TEST_CONTROL_ATTRIBUTES_TEMPORARY]: documentTypes.CONTROL_TEST_CONTROL_ATTRIBUTES,
			[documentTypes.SCOT_WALKTHROUGH_TEMPORARY]: documentTypes.SCOT_WALKTHROUGH,
			[documentTypes.Estimate_Individual_Estimate_Temporary]: documentTypes.ESTIMATESDOCUMENT
		};

		const newDocTypeId =
			document.documentTypeId === documentTypes.CRASH && document.fileExt
				? documentTypes.EVIDENCE
				: !document.fileExt
				? documentTypes.PAPERPROFILE
				: documentTypeMap[document.documentTypeId];

		return newDocTypeId;
	};

	static excludeDaasInprogressDocuments = (documents) => {
		// exclude documents from List if contentContractId is DaaS and documentStatusId is DaaSCheckoutInProgress
		documents = documents.filter(
			(document) =>
				!(
					document.documentStatusId == DocumentStatus.DaaSCheckoutInProgress ||
					document.contentContractId == ContentContract.DaaS
				)
		);

		return documents;
	};

	static triggerBenefitServiceCall = (dispatch, benefitId, engagementId) => {
		if (envConfig.benefit.enableBenefitService === 'true') {
			dispatch(benefitServiceIntegrationAction(benefitId, engagementId)).catch((e) => {
				console.error('Error in benefit service integration:', e);
			});
		}
	};
}

export default Utility;
